<template>
  <div
    class="generator game-room container"
    v-if="roomInfo"
    v-bind:class="{'px-0': generatorAsExtension, styleTemplate: styleTemplate}"
  >
    <div class="full-page-background"></div>
    <div v-html="customOptions.style"></div>

    <!-- Menu Bar -->
    <div class="menu-bar mb-4 d-flex align-items-center" v-if="!generatorAsExtension">
      <button class="btn btn-outline-dark mr-auto border-0" v-b-modal.menuModal v-bind:style="{color: customOptions.menuColor}"><b-icon-list></b-icon-list> Menu</button>
      <!-- <div v-if="customOptions.gameTitle" class="mx-auto align-middle text-center">{{customOptions.gameTitle}}</div> -->
      <app-roomLink class="d-none d-sm-block" :routeRoomID="$route.params.roomID" :color="customOptions.menuColor" v-if="dataReady && firebaseReady"></app-roomLink>
      
      <b-modal
        id="menuModal"
        :title="customOptions.gameTitle ? customOptions.gameTitle : 'Menu'" 
        hide-footer
      >  
        <b-container>
          <div class="row menu-row">
            <b-button
              class="border-0 btn-lg btn-block"
              v-on:click="copyLinkToClipboard(); closeMenu();"
              @click="$bvToast.show('copyToast')"
            >
              <b-icon-link45deg></b-icon-link45deg> Copy URL 
            </b-button>
          </div>
        </b-container>
        <div class="" v-if="customOptions.modalOneLabel || customOptions.modalTwoLabel">
          <hr class='mb-4'/>
          <b-button
            v-b-modal.modalOne
            v-on:click="closeMenu();"
            variant="outline-dark"
            class="btn-block btn-lg"
            v-if="customOptions.modalOneLabel"
          >
            {{ customOptions.modalOneLabel }}
          </b-button>
          <b-button
            v-b-modal.modalTwo
            v-on:click="closeMenu();"
            variant="outline-dark"
            class="btn-block btn-lg"
            v-if="customOptions.modalTwoLabel"
            >{{ customOptions.modalTwoLabel }}</b-button
          >
        </div>
        <div class="row menu-row mt-4">
          <a href="https://storysynth.org" target="_blank">Powered by Story Synth</a>
        </div>
      </b-modal>
    </div>

    <b-alert show class="demoInfo" variant="info" v-if="customOptions.demoInfo">This demo is powered by <a :href="customOptions.demoInfo" target="_blank">this Google Sheet Template</a>. Copy the sheet and start editing it to design your own game!</b-alert>

    <div class="game-meta">
      <div class="mb-4" v-if="customOptions.gameTitle || customOptions.byline">
        <div class="row text-center" v-if="customOptions.gameTitle">
          <div class="col-sm">
            <h1>{{ customOptions.gameTitle }}</h1>
          </div>
        </div>

        <div class="row text-center" v-if="customOptions.byline">
          <div class="col-sm">
            <h4>{{ customOptions.byline }}</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="upper-text row" v-if="customOptions.upperText">
      <div
        class="col-sm"
        style="white-space: pre-line"
        v-html="customOptions.upperText"
      ></div>
    </div>

    <div
        v-if="
          dataReady &&
            firebaseReady &&
            roomInfo &&
            Object.keys(roomInfo.extensionData).length > 1
        "
      >
        <app-extensionManager
          @sync-extension="syncExtension()"
          :extensionData="roomInfo.extensionData"
          :extensionList="tempExtensionData"
          :roomInfo="roomInfo"
          :extensionLocation="'upper'"
          class="extension-upper"
        ></app-extensionManager>
      </div>

    <div class="row">
      <div
        class="btn-group col-sm"
        role="group"
        aria-label="Extra Info"
        v-if="customOptions.modalOneLabel || customOptions.modalTwoLabel"
      >
        <!-- <b-button
          v-b-modal.modalOne
          variant="outline-dark"
          v-if="customOptions.modalOneLabel"
          >{{ customOptions.modalOneLabel }}</b-button
        > -->

        <b-modal
          id="modalOne"
          v-bind:title="customOptions.modalOneLabel"
          hide-footer
        >
          <div
            class="d-block text-left"
            style="white-space: pre-line"
            v-html="customOptions.modalOneText"
          ></div>
        </b-modal>

        <!-- <b-button
          v-b-modal.modalTwo
          variant="outline-dark"
          v-if="customOptions.modalTwoLabel"
          >{{ customOptions.modalTwoLabel }}</b-button
        > -->

        <b-modal
          id="modalTwo"
          v-bind:title="customOptions.modalTwoLabel"
          hide-footer
        >
          <div
            class="d-block text-left"
            style="white-space: pre-line"
            v-html="customOptions.modalTwoText"
          ></div>
        </b-modal>
      </div>
    </div>

    <div class="mb-4">
      <div
        class="d-flex shadow img-fluid"
        v-if="(!dataReady || !firebaseReady) && !error"
      >
        <div class="card-body text-center">
          <h1 class="m-5">Loading</h1>
          <b-spinner
            class="m-5"
            style="width: 4rem; height: 4rem"
            label="Busy"
          ></b-spinner>
        </div>
      </div>

      <div class="mt-4 generator-main card shadow mb-4">
        <div class="game-title-on-card mt-4" v-if="customOptions.gameTitle && customOptions.showGameTitleOnCard">
          <h1>{{customOptions.gameTitle}}</h1>
        </div>
        <div class="regenerate-button my-4">
          <b-form inline class="justify-content-center">
            <b-button v-on:click="shuffleAll()" class="btn btn-dark mx-2 my-1">
              <span>Randomize All</span> <b-icon class='generator-cell-reroll-icon' icon="arrow-clockwise"></b-icon>
            </b-button>
            <b-form-select v-model="generatorView" class="mx-2 my-1" v-if="customOptions.showSummary || customOptions.showFullLists">
              <b-form-select-option value="Grid View">Grid View</b-form-select-option>
              <b-form-select-option value="Summary View" v-if="customOptions.showSummary">Summary View</b-form-select-option>
              <b-form-select-option value="Full View" v-if="customOptions.showFullLists">Full View</b-form-select-option>
            </b-form-select>
          </b-form>
        </div>

        
        <div class='pl-3 pr-3' v-if="generatorView == 'Grid View'">
          
          <div class="row generator-row">
            <button
              v-for="index in numberOfCategories"
              v-bind:key="index"
              v-bind:class="customOptions.generatorRowLayout[index - 1]"
              v-on:click="shuffleOne(index)"
              tabindex="0"
            >
              <transition name="reroll" mode="out-in">
                <div 
                  class="mt-4 mb-3 generator-cell-contents"
                  :key="
                    categoryData[index - 1][
                      roomInfo.currentGeneratorSelection[index - 1]
                    ]
                  "
                >
                  <div class="mb-2">
                    <div
                      v-html="categoryLabels[index - 1]"
                      v-if="!customOptions.hideLabels"
                      class="generator-cell-label px-2"
                    ></div>
                  </div>
                  
                    <div
                      :key="
                        categoryData[index - 1][
                          roomInfo.currentGeneratorSelection[index - 1]
                        ]
                      "
                      v-html="
                        categoryData[index - 1][
                          roomInfo.currentGeneratorSelection[index - 1]
                        ]
                      "
                      class="generator-cell-body mb-2"
                      v-bind:class="{'generator-cell-full-small': String(categoryData[index - 1][roomInfo.currentGeneratorSelection[index - 1]]).length >= 50}"
                    ></div>
                  <div class="generator-cell-reroll-button" v-if="categoryData[index - 1][
                          roomInfo.currentGeneratorSelection[index - 1]
                        ] && (categoryData[index-1].length > 1)">
                    <span>Reroll</span> <b-icon class='generator-cell-reroll-icon' icon="arrow-clockwise"></b-icon>
                  </div>
                </div>
              </transition>
            </button>
          </div>
        </div>

        <div class='pl-3 pr-3' v-if="generatorView == 'Summary View'">
          <div class="row generator-summary text-left my-5">
            <div
              v-for="index in numberOfCategories"
              v-bind:key="index"
              class="col-12"
            >
              <div v-on:click="shuffleOne(index)" class="" style="white-space: pre-line;">
                <span
                  v-html="categoryLabels[index - 1] + ':'"
                  v-if="!customOptions.hideLabels"
                  class="summary-category-label px-2 font-weight-bold"
                ></span>
                <transition-group name="reroll-list" mode="out-in">
                  <span
                    :key="
                      roomInfo.currentGeneratorSelection[index - 1]
                    "
                    v-html="
                      categoryData[index - 1][
                        roomInfo.currentGeneratorSelection[index - 1]
                      ]
                    "
                    class="summary-category-body font-weight-normal mb-2"
                  ></span>
                </transition-group>
                <b-icon v-on:click="shuffleOne(index)" class='ml-2 generator-cell-reroll-icon' icon="arrow-clockwise"></b-icon>
              </div>
            </div>
          </div>
        </div>

        <div class='pl-3 pr-3' v-if="generatorView == 'Full View'">
          <div class="row generator-row generator-full">
            <div
              v-for="index in numberOfCategories"
              v-bind:key="index"
              v-bind:class="customOptions.generatorRowLayout[index - 1]"
            >
              <div class="my-4 generator-cell-contents">
                <div class="mb-2">
                  <div
                    v-html="categoryLabels[index - 1]"
                    v-on:click="shuffleOne(index)"
                    v-if="!customOptions.hideLabels"
                    class="generator-cell-label px-2"
                  ></div>
                </div>
                <!-- <div
                  v-for="(option, optionIndex) in categoryData[index - 1]"
                  v-bind:key="option"
                >
                  <transition name="reroll-list" mode="out-in">
                    <span
                      v-html="option"
                      v-on:click="selectOne(index, optionIndex)"
                      class="font-weight-normal"
                      v-bind:class="{
                        'font-weight-bolder':
                          option ==
                          categoryData[index - 1][
                            roomInfo.currentGeneratorSelection[index - 1]
                          ],
                      }"
                      style="cursor: pointer;"
                      :key="roomInfo.currentGeneratorSelection[index - 1]"
                    ></span>
                  </transition>
                </div> -->
                <div
                  v-on:click="shuffleOne(index)"
                  class="generator-cell-reroll-button"
                  v-if="customOptions.rerollButton"
                >
                  <span>Random</span> <b-icon class='generator-cell-reroll-icon' icon="arrow-clockwise"></b-icon>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="lower-text row mt-4" v-if="customOptions.lowerText">
        <div class="col-sm" v-html="customOptions.lowerText"></div>
      </div>
    </div>

    <div
      v-if="
        dataReady &&
          firebaseReady &&
          roomInfo &&
          Object.keys(roomInfo.extensionData).length > 1
      "
    >
      <app-extensionManager
        @sync-extension="syncExtension()"
        :extensionData="roomInfo.extensionData"
        :extensionList="tempExtensionData"
        :roomInfo="roomInfo"
        :extensionLocation="'lower'"
        class="extension-lower"
      ></app-extensionManager>
    </div>
  </div>
</template>

<script>
import { roomsCollection } from "../../firebase";
import ExtensionManager from "../extensions/ExtensionManager.vue";
// import axios from "axios";
import RoomLink from '../layout/RoomLink.vue';

export default {
  name: "app-generator",
  components: {
    "app-extensionManager": ExtensionManager,
    'app-roomLink': RoomLink,
  },
  props: {
    roomID: String,
    gSheetID: String,
    generatorAsExtension: Boolean,
  },

  data: function () {
    return {
      roomInfo: {
        currentGeneratorSelection: [],
        nameAllRoom: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
        headAllRoom: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        torsoAllRoom: [0, 1, 2, 3, 4, 5, 6],
        legsAllRoom: [0, 1, 2],
        headClothingRoom: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
        torsoClothingRoom: [0, 1, 2, 3, 4, 5],
        legsClothingRoom: [0, 1, 2, 3, 4],
      },
      dataReady: false,
      firebaseReady: false,
      gSheet: [{ text: "loading" }],
      generatorLayout: [],
      generatorView: 'Grid View',
      numberOfCategories: 42,
      categoryLabels: ["Arrow left","Name","Arrow right","Arrow left","Head1","Arrow right","Arrow left","Head2","Arrow right","Arrow left","Torso1","Arrow right","Arrow left","Torso2","Arrow right","Arrow left","Legs1","Arrow right","Arrow left","Legs2","Arrow right","Arrow left","Name","Arrow right"],
      categoryData: [
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    ["Blair","Kai","Grey","Quinn","Jaime","Mel","Theo","Elli","Kris","Em&nbsp;","Nat","Peggy","Dee","Turner","Minnie","Ella","Lea","Lou","Jo","Fran","Etta","Hazel","Pat","Ed","Ira","Leo","Al","Marion","Jim&nbsp;","Bea","Earnest","Oscar","Vic","Kim&nbsp;","Jenny","Luci","Eli","Cecil","Aubrey","Baxter","Violet"],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    ///heads
        ["<img src=\"/images/head-berrymushroom.png\"/>",
        "<img src=\"/images/head-bird.png\"/>",
        "<img src=\"/images/head-brain.png\"/>",
        "<img src=\"/images/head-cat.png\"/>",
        "<img src=\"/images/head-caterpillar.png\"/>",
        "<img src=\"/images/head-dog.png\"/>",
        "<img src=\"/images/head-giraffe.png\"/>",
        "<img src=\"/images/head-jellyfish.png\"/>",
        "<img src=\"/images/head-mantis.png\"/>",
        "<img src=\"/images/head-mushroom.png\"/>",
        "<img src=\"/images/head-robot.png\"/>",
        "<img src=\"/images/head-snail.png\"/>",
        "<img src=\"/images/head-whorobot.png\"/>"],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //heads clothing
        ["<img src=\"/images/head-berrymushroom-bluehat.png\"/>",
        "<img src=\"/images/head-berrymushroom-cap.png\"/>",
        "<img src=\"/images/head-berrymushroom-detective.png\"/>",
        "<img src=\"/images/head-berrymushroom-featherhat.png\"/>",
        "<img src=\"/images/head-berrymushroom-fedora.png\"/>",
        "<img src=\"/images/head-berrymushroom-felt.png\"/>",
        "<img src=\"/images/head-berrymushroom-fez.png\"/>",
        "<img src=\"/images/head-berrymushroom-gangster.png\"/>",
        "<img src=\"/images/head-berrymushroom-knit.png\"/>",
        "<img src=\"/images/head-berrymushroom-lady.png\"/>",
        "<img src=\"/images/head-berrymushroom-mage.png\"/>",
        "<img src=\"/images/head-berrymushroom-military.png\"/>",
        "<img src=\"/images/head-berrymushroom-officer.png\"/>",
        "<img src=\"/images/head-berrymushroom-pirate.png\"/>",
        "<img src=\"/images/head-berrymushroom-sixpence.png\"/>",
        "<img src=\"/images/head-berrymushroom-straw.png\"/>",
        "<img src=\"/images/head-berrymushroom-summer.png\"/>",
        "<img src=\"/images/head-berrymushroom-tophat.png\"/>",
        "<img src=\"/images/head-bird-bluehat.png\"/>",
        "<img src=\"/images/head-bird-cap.png\"/>",
        "<img src=\"/images/head-bird-detective.png\"/>",
        "<img src=\"/images/head-bird-featherhat.png\"/>",
        "<img src=\"/images/head-bird-fedora.png\"/>",
        "<img src=\"/images/head-bird-felt.png\"/>",
        "<img src=\"/images/head-bird-fez.png\"/>",
        "<img src=\"/images/head-bird-gangster.png\"/>",
        "<img src=\"/images/head-bird-knit.png\"/>",
        "<img src=\"/images/head-bird-lady.png\"/>",
        "<img src=\"/images/head-bird-mage.png\"/>",
        "<img src=\"/images/head-bird-military.png\"/>",
        "<img src=\"/images/head-bird-officer.png\"/>",
        "<img src=\"/images/head-bird-pirate.png\"/>",
        "<img src=\"/images/head-bird-sixpence.png\"/>",
        "<img src=\"/images/head-bird-straw.png\"/>",
        "<img src=\"/images/head-bird-summer.png\"/>",
        "<img src=\"/images/head-bird-tophat.png\"/>",
        "<img src=\"/images/head-brain-bluehat.png\"/>",
        "<img src=\"/images/head-brain-cap.png\"/>",
        "<img src=\"/images/head-brain-detective.png\"/>",
        "<img src=\"/images/head-brain-featherhat.png\"/>",
        "<img src=\"/images/head-brain-fedora.png\"/>",
        "<img src=\"/images/head-brain-felt.png\"/>",
        "<img src=\"/images/head-brain-fez.png\"/>",
        "<img src=\"/images/head-brain-gangster.png\"/>",
        "<img src=\"/images/head-brain-knit.png\"/>",
        "<img src=\"/images/head-brain-lady.png\"/>",
        "<img src=\"/images/head-brain-mage.png\"/>",
        "<img src=\"/images/head-brain-military.png\"/>",
        "<img src=\"/images/head-brain-officer.png\"/>",
        "<img src=\"/images/head-brain-pirate.png\"/>",
        "<img src=\"/images/head-brain-sixpence.png\"/>",
        "<img src=\"/images/head-brain-straw.png\"/>",
        "<img src=\"/images/head-brain-summer.png\"/>",
        "<img src=\"/images/head-brain-tophat.png\"/>",
        "<img src=\"/images/head-cat-bluehat.png\"/>",
        "<img src=\"/images/head-cat-cap.png\"/>",
        "<img src=\"/images/head-cat-detective.png\"/>",
        "<img src=\"/images/head-cat-featherhat.png\"/>",
        "<img src=\"/images/head-cat-fedora.png\"/>",
        "<img src=\"/images/head-cat-felt.png\"/>",
        "<img src=\"/images/head-cat-fez.png\"/>",
        "<img src=\"/images/head-cat-gangster.png\"/>",
        "<img src=\"/images/head-cat-knit.png\"/>",
        "<img src=\"/images/head-cat-lady.png\"/>",
        "<img src=\"/images/head-cat-mage.png\"/>",
        "<img src=\"/images/head-cat-military.png\"/>",
        "<img src=\"/images/head-cat-officer.png\"/>",
        "<img src=\"/images/head-cat-pirate.png\"/>",
        "<img src=\"/images/head-cat-sixpence.png\"/>",
        "<img src=\"/images/head-cat-straw.png\"/>",
        "<img src=\"/images/head-cat-summer.png\"/>",
        "<img src=\"/images/head-cat-tophat.png\"/>",
        "<img src=\"/images/head-caterpillar-bluehat.png\"/>",
        "<img src=\"/images/head-caterpillar-cap.png\"/>",
        "<img src=\"/images/head-caterpillar-detective.png\"/>",
        "<img src=\"/images/head-caterpillar-featherhat.png\"/>",
        "<img src=\"/images/head-caterpillar-fedora.png\"/>",
        "<img src=\"/images/head-caterpillar-felt.png\"/>",
        "<img src=\"/images/head-caterpillar-fez.png\"/>",
        "<img src=\"/images/head-caterpillar-gangster.png\"/>",
        "<img src=\"/images/head-caterpillar-knit.png\"/>",
        "<img src=\"/images/head-caterpillar-lady.png\"/>",
        "<img src=\"/images/head-caterpillar-mage.png\"/>",
        "<img src=\"/images/head-caterpillar-military.png\"/>",
        "<img src=\"/images/head-caterpillar-officer.png\"/>",
        "<img src=\"/images/head-caterpillar-pirate.png\"/>",
        "<img src=\"/images/head-caterpillar-sixpence.png\"/>",
        "<img src=\"/images/head-caterpillar-straw.png\"/>",
        "<img src=\"/images/head-caterpillar-summer.png\"/>",
        "<img src=\"/images/head-caterpillar-tophat.png\"/>",
        "<img src=\"/images/head-dog-bluehat.png\"/>",
        "<img src=\"/images/head-dog-cap.png\"/>",
        "<img src=\"/images/head-dog-detective.png\"/>",
        "<img src=\"/images/head-dog-featherhat.png\"/>",
        "<img src=\"/images/head-dog-fedora.png\"/>",
        "<img src=\"/images/head-dog-felt.png\"/>",
        "<img src=\"/images/head-dog-fez.png\"/>",
        "<img src=\"/images/head-dog-gangster.png\"/>",
        "<img src=\"/images/head-dog-knit.png\"/>",
        "<img src=\"/images/head-dog-lady.png\"/>",
        "<img src=\"/images/head-dog-mage.png\"/>",
        "<img src=\"/images/head-dog-military.png\"/>",
        "<img src=\"/images/head-dog-officer.png\"/>",
        "<img src=\"/images/head-dog-pirate.png\"/>",
        "<img src=\"/images/head-dog-sixpence.png\"/>",
        "<img src=\"/images/head-dog-straw.png\"/>",
        "<img src=\"/images/head-dog-summer.png\"/>",
        "<img src=\"/images/head-dog-tophat.png\"/>",
        "<img src=\"/images/head-giraffe-bluehat.png\"/>",
        "<img src=\"/images/head-giraffe-cap.png\"/>",
        "<img src=\"/images/head-giraffe-detective.png\"/>",
        "<img src=\"/images/head-giraffe-featherhat.png\"/>",
        "<img src=\"/images/head-giraffe-fedora.png\"/>",
        "<img src=\"/images/head-giraffe-felt.png\"/>",
        "<img src=\"/images/head-giraffe-fez.png\"/>",
        "<img src=\"/images/head-giraffe-gangster.png\"/>",
        "<img src=\"/images/head-giraffe-knit.png\"/>",
        "<img src=\"/images/head-giraffe-lady.png\"/>",
        "<img src=\"/images/head-giraffe-mage.png\"/>",
        "<img src=\"/images/head-giraffe-military.png\"/>",
        "<img src=\"/images/head-giraffe-officer.png\"/>",
        "<img src=\"/images/head-giraffe-pirate.png\"/>",
        "<img src=\"/images/head-giraffe-sixpence.png\"/>",
        "<img src=\"/images/head-giraffe-straw.png\"/>",
        "<img src=\"/images/head-giraffe-summer.png\"/>",
        "<img src=\"/images/head-giraffe-tophat.png\"/>",
        "<img src=\"/images/head-jellyfish-bluehat.png\"/>",
        "<img src=\"/images/head-jellyfish-cap.png\"/>",
        "<img src=\"/images/head-jellyfish-detective.png\"/>",
        "<img src=\"/images/head-jellyfish-featherhat.png\"/>",
        "<img src=\"/images/head-jellyfish-fedora.png\"/>",
        "<img src=\"/images/head-jellyfish-felt.png\"/>",
        "<img src=\"/images/head-jellyfish-fez.png\"/>",
        "<img src=\"/images/head-jellyfish-gangster.png\"/>",
        "<img src=\"/images/head-jellyfish-knit.png\"/>",
        "<img src=\"/images/head-jellyfish-lady.png\"/>",
        "<img src=\"/images/head-jellyfish-mage.png\"/>",
        "<img src=\"/images/head-jellyfish-military.png\"/>",
        "<img src=\"/images/head-jellyfish-officer.png\"/>",
        "<img src=\"/images/head-jellyfish-pirate.png\"/>",
        "<img src=\"/images/head-jellyfish-sixpence.png\"/>",
        "<img src=\"/images/head-jellyfish-straw.png\"/>",
        "<img src=\"/images/head-jellyfish-summer.png\"/>",
        "<img src=\"/images/head-jellyfish-tophat.png\"/>",
        "<img src=\"/images/head-mantis-bluehat.png\"/>",
        "<img src=\"/images/head-mantis-cap.png\"/>",
        "<img src=\"/images/head-mantis-detective.png\"/>",
        "<img src=\"/images/head-mantis-featherhat.png\"/>",
        "<img src=\"/images/head-mantis-fedora.png\"/>",
        "<img src=\"/images/head-mantis-felt.png\"/>",
        "<img src=\"/images/head-mantis-fez.png\"/>",
        "<img src=\"/images/head-mantis-gangster.png\"/>",
        "<img src=\"/images/head-mantis-knit.png\"/>",
        "<img src=\"/images/head-mantis-lady.png\"/>",
        "<img src=\"/images/head-mantis-mage.png\"/>",
        "<img src=\"/images/head-mantis-military.png\"/>",
        "<img src=\"/images/head-mantis-officer.png\"/>",
        "<img src=\"/images/head-mantis-pirate.png\"/>",
        "<img src=\"/images/head-mantis-sixpence.png\"/>",
        "<img src=\"/images/head-mantis-straw.png\"/>",
        "<img src=\"/images/head-mantis-summer.png\"/>",
        "<img src=\"/images/head-mantis-tophat.png\"/>",
        "<img src=\"/images/head-mushroom-bluehat.png\"/>",
        "<img src=\"/images/head-mushroom-cap.png\"/>",
        "<img src=\"/images/head-mushroom-detective.png\"/>",
        "<img src=\"/images/head-mushroom-featherhat.png\"/>",
        "<img src=\"/images/head-mushroom-fedora.png\"/>",
        "<img src=\"/images/head-mushroom-felt.png\"/>",
        "<img src=\"/images/head-mushroom-fez.png\"/>",
        "<img src=\"/images/head-mushroom-gangster.png\"/>",
        "<img src=\"/images/head-mushroom-knit.png\"/>",
        "<img src=\"/images/head-mushroom-lady.png\"/>",
        "<img src=\"/images/head-mushroom-mage.png\"/>",
        "<img src=\"/images/head-mushroom-military.png\"/>",
        "<img src=\"/images/head-mushroom-officer.png\"/>",
        "<img src=\"/images/head-mushroom-pirate.png\"/>",
        "<img src=\"/images/head-mushroom-sixpence.png\"/>",
        "<img src=\"/images/head-mushroom-straw.png\"/>",
        "<img src=\"/images/head-mushroom-summer.png\"/>",
        "<img src=\"/images/head-mushroom-tophat.png\"/>",
        "<img src=\"/images/head-robot-bluehat.png\"/>",
        "<img src=\"/images/head-robot-cap.png\"/>",
        "<img src=\"/images/head-robot-detective.png\"/>",
        "<img src=\"/images/head-robot-featherhat.png\"/>",
        "<img src=\"/images/head-robot-fedora.png\"/>",
        "<img src=\"/images/head-robot-felt.png\"/>",
        "<img src=\"/images/head-robot-fez.png\"/>",
        "<img src=\"/images/head-robot-gangster.png\"/>",
        "<img src=\"/images/head-robot-knit.png\"/>",
        "<img src=\"/images/head-robot-lady.png\"/>",
        "<img src=\"/images/head-robot-mage.png\"/>",
        "<img src=\"/images/head-robot-military.png\"/>",
        "<img src=\"/images/head-robot-officer.png\"/>",
        "<img src=\"/images/head-robot-pirate.png\"/>",
        "<img src=\"/images/head-robot-sixpence.png\"/>",
        "<img src=\"/images/head-robot-straw.png\"/>",
        "<img src=\"/images/head-robot-summer.png\"/>",
        "<img src=\"/images/head-robot-tophat.png\"/>",
        "<img src=\"/images/head-snail-bluehat.png\"/>",
        "<img src=\"/images/head-snail-cap.png\"/>",
        "<img src=\"/images/head-snail-detective.png\"/>",
        "<img src=\"/images/head-snail-featherhat.png\"/>",
        "<img src=\"/images/head-snail-fedora.png\"/>",
        "<img src=\"/images/head-snail-felt.png\"/>",
        "<img src=\"/images/head-snail-fez.png\"/>",
        "<img src=\"/images/head-snail-gangster.png\"/>",
        "<img src=\"/images/head-snail-knit.png\"/>",
        "<img src=\"/images/head-snail-lady.png\"/>",
        "<img src=\"/images/head-snail-mage.png\"/>",
        "<img src=\"/images/head-snail-military.png\"/>",
        "<img src=\"/images/head-snail-officer.png\"/>",
        "<img src=\"/images/head-snail-pirate.png\"/>",
        "<img src=\"/images/head-snail-sixpence.png\"/>",
        "<img src=\"/images/head-snail-straw.png\"/>",
        "<img src=\"/images/head-snail-summer.png\"/>",
        "<img src=\"/images/head-snail-tophat.png\"/>",
        "<img src=\"/images/head-whorobot-bluehat.png\"/>",
        "<img src=\"/images/head-whorobot-cap.png\"/>",
        "<img src=\"/images/head-whorobot-detective.png\"/>",
        "<img src=\"/images/head-whorobot-featherhat.png\"/>",
        "<img src=\"/images/head-whorobot-fedora.png\"/>",
        "<img src=\"/images/head-whorobot-felt.png\"/>",
        "<img src=\"/images/head-whorobot-fez.png\"/>",
        "<img src=\"/images/head-whorobot-gangster.png\"/>",
        "<img src=\"/images/head-whorobot-knit.png\"/>",
        "<img src=\"/images/head-whorobot-lady.png\"/>",
        "<img src=\"/images/head-whorobot-mage.png\"/>",
        "<img src=\"/images/head-whorobot-military.png\"/>",
        "<img src=\"/images/head-whorobot-officer.png\"/>",
        "<img src=\"/images/head-whorobot-pirate.png\"/>",
        "<img src=\"/images/head-whorobot-sixpence.png\"/>",
        "<img src=\"/images/head-whorobot-straw.png\"/>",
        "<img src=\"/images/head-whorobot-summer.png\"/>",
        "<img src=\"/images/head-whorobot-tophat.png\"/>"
],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //torsos
        ["<img src=\"/images/torso-amoeba.png\"/>",
        "<img src=\"/images/torso-bird.png\"/>",
        "<img src=\"/images/torso-bluefrog.png\"/>",
        "<img src=\"/images/torso-frog.png\"/>",
        "<img src=\"/images/torso-furry.png\"/>",
        "<img src=\"/images/torso-heart.png\"/>",
        "<img src=\"/images/torso-insect.png\"/>",
        "<img src=\"/images/torso-jellyfish.png\"/>",
        "<img src=\"/images/torso-lichen.png\"/>",
        "<img src=\"/images/torso-monkey.png\"/>",
        "<img src=\"/images/torso-mushroom.png\"/>",
        "<img src=\"/images/torso-robot.png\"/>",
        "<img src=\"/images/torso-rocktopus.png\"/>"
    ],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //torsos clothing
        ["<img src=\"/images/torso-amoeba-cape.png\"/>",
        "<img src=\"/images/torso-amoeba-flannel.png\"/>",
        "<img src=\"/images/torso-amoeba-frills.png\"/>",
        "<img src=\"/images/torso-amoeba-kimono.png\"/>",
        "<img src=\"/images/torso-amoeba-leathervest.png\"/>",
        "<img src=\"/images/torso-amoeba-punkvest.png\"/>",
        "<img src=\"/images/torso-amoeba-shortsleeves.png\"/>",
        "<img src=\"/images/torso-amoeba-suspenders.png\"/>",
        "<img src=\"/images/torso-amoeba-swedish.png\"/>",
        "<img src=\"/images/torso-amoeba-tanktop.png\"/>",
        "<img src=\"/images/torso-amoeba-winter.png\"/>",
        "<img src=\"/images/torso-bird-cape.png\"/>",
        "<img src=\"/images/torso-bird-flannel.png\"/>",
        "<img src=\"/images/torso-bird-frills.png\"/>",
        "<img src=\"/images/torso-bird-kimono.png\"/>",
        "<img src=\"/images/torso-bird-leathervest.png\"/>",
        "<img src=\"/images/torso-bird-punkvest.png\"/>",
        "<img src=\"/images/torso-bird-shortsleeves.png\"/>",
        "<img src=\"/images/torso-bird-suspenders.png\"/>",
        "<img src=\"/images/torso-bird-swedish.png\"/>",
        "<img src=\"/images/torso-bird-tanktop.png\"/>",
        "<img src=\"/images/torso-bird-winter.png\"/>",
        "<img src=\"/images/torso-bluefrog-cape.png\"/>",
        "<img src=\"/images/torso-bluefrog-flannel.png\"/>",
        "<img src=\"/images/torso-bluefrog-frills.png\"/>",
        "<img src=\"/images/torso-bluefrog-kimono.png\"/>",
        "<img src=\"/images/torso-bluefrog-leathervest.png\"/>",
        "<img src=\"/images/torso-bluefrog-punkvest.png\"/>",
        "<img src=\"/images/torso-bluefrog-shortsleeves.png\"/>",
        "<img src=\"/images/torso-bluefrog-suspenders.png\"/>",
        "<img src=\"/images/torso-bluefrog-swedish.png\"/>",
        "<img src=\"/images/torso-bluefrog-tanktop.png\"/>",
        "<img src=\"/images/torso-bluefrog-winter.png\"/>",
        "<img src=\"/images/torso-frog-cape.png\"/>",
        "<img src=\"/images/torso-frog-flannel.png\"/>",
        "<img src=\"/images/torso-frog-frills.png\"/>",
        "<img src=\"/images/torso-frog-kimono.png\"/>",
        "<img src=\"/images/torso-frog-leathervest.png\"/>",
        "<img src=\"/images/torso-frog-punkvest.png\"/>",
        "<img src=\"/images/torso-frog-shortsleeves.png\"/>",
        "<img src=\"/images/torso-frog-suspenders.png\"/>",
        "<img src=\"/images/torso-frog-swedish.png\"/>",
        "<img src=\"/images/torso-frog-tanktop.png\"/>",
        "<img src=\"/images/torso-frog-winter.png\"/>",
        "<img src=\"/images/torso-furry-cape.png\"/>",
        "<img src=\"/images/torso-furry-flannel.png\"/>",
        "<img src=\"/images/torso-furry-frills.png\"/>",
        "<img src=\"/images/torso-furry-kimono.png\"/>",
        "<img src=\"/images/torso-furry-leathervest.png\"/>",
        "<img src=\"/images/torso-furry-punkvest.png\"/>",
        "<img src=\"/images/torso-furry-shortsleeves.png\"/>",
        "<img src=\"/images/torso-furry-suspenders.png\"/>",
        "<img src=\"/images/torso-furry-swedish.png\"/>",
        "<img src=\"/images/torso-furry-tanktop.png\"/>",
        "<img src=\"/images/torso-furry-winter.png\"/>",
        "<img src=\"/images/torso-heart-cape.png\"/>",
        "<img src=\"/images/torso-heart-flannel.png\"/>",
        "<img src=\"/images/torso-heart-frills.png\"/>",
        "<img src=\"/images/torso-heart-kimono.png\"/>",
        "<img src=\"/images/torso-heart-leathervest.png\"/>",
        "<img src=\"/images/torso-heart-punkvest.png\"/>",
        "<img src=\"/images/torso-heart-shortsleeves.png\"/>",
        "<img src=\"/images/torso-heart-suspenders.png\"/>",
        "<img src=\"/images/torso-heart-swedish.png\"/>",
        "<img src=\"/images/torso-heart-tanktop.png\"/>",
        "<img src=\"/images/torso-heart-winter.png\"/>",
        "<img src=\"/images/torso-insect-cape.png\"/>",
        "<img src=\"/images/torso-insect-flannel.png\"/>",
        "<img src=\"/images/torso-insect-frills.png\"/>",
        "<img src=\"/images/torso-insect-kimono.png\"/>",
        "<img src=\"/images/torso-insect-leathervest.png\"/>",
        "<img src=\"/images/torso-insect-punkvest.png\"/>",
        "<img src=\"/images/torso-insect-shortsleeves.png\"/>",
        "<img src=\"/images/torso-insect-suspenders.png\"/>",
        "<img src=\"/images/torso-insect-swedish.png\"/>",
        "<img src=\"/images/torso-insect-tanktop.png\"/>",
        "<img src=\"/images/torso-insect-winter.png\"/>",
        "<img src=\"/images/torso-jellyfish-cape.png\"/>",
        "<img src=\"/images/torso-jellyfish-flannel.png\"/>",
        "<img src=\"/images/torso-jellyfish-frills.png\"/>",
        "<img src=\"/images/torso-jellyfish-kimono.png\"/>",
        "<img src=\"/images/torso-jellyfish-leathervest.png\"/>",
        "<img src=\"/images/torso-jellyfish-punkvest.png\"/>",
        "<img src=\"/images/torso-jellyfish-shortsleeves.png\"/>",
        "<img src=\"/images/torso-jellyfish-suspenders.png\"/>",
        "<img src=\"/images/torso-jellyfish-swedish.png\"/>",
        "<img src=\"/images/torso-jellyfish-tanktop.png\"/>",
        "<img src=\"/images/torso-jellyfish-winter.png\"/>",
        "<img src=\"/images/torso-lichen-cape.png\"/>",
        "<img src=\"/images/torso-lichen-flannel.png\"/>",
        "<img src=\"/images/torso-lichen-frills.png\"/>",
        "<img src=\"/images/torso-lichen-kimono.png\"/>",
        "<img src=\"/images/torso-lichen-leathervest.png\"/>",
        "<img src=\"/images/torso-lichen-punkvest.png\"/>",
        "<img src=\"/images/torso-lichen-shortsleeves.png\"/>",
        "<img src=\"/images/torso-lichen-suspenders.png\"/>",
        "<img src=\"/images/torso-lichen-swedish.png\"/>",
        "<img src=\"/images/torso-lichen-tanktop.png\"/>",
        "<img src=\"/images/torso-lichen-winter.png\"/>",
        "<img src=\"/images/torso-monkey-cape.png\"/>",
        "<img src=\"/images/torso-monkey-flannel.png\"/>",
        "<img src=\"/images/torso-monkey-frills.png\"/>",
        "<img src=\"/images/torso-monkey-kimono.png\"/>",
        "<img src=\"/images/torso-monkey-leathervest.png\"/>",
        "<img src=\"/images/torso-monkey-punkvest.png\"/>",
        "<img src=\"/images/torso-monkey-shortsleeves.png\"/>",
        "<img src=\"/images/torso-monkey-suspenders.png\"/>",
        "<img src=\"/images/torso-monkey-swedish.png\"/>",
        "<img src=\"/images/torso-monkey-tanktop.png\"/>",
        "<img src=\"/images/torso-monkey-winter.png\"/>",
        "<img src=\"/images/torso-mushroom-cape.png\"/>",
        "<img src=\"/images/torso-mushroom-flannel.png\"/>",
        "<img src=\"/images/torso-mushroom-frills.png\"/>",
        "<img src=\"/images/torso-mushroom-kimono.png\"/>",
        "<img src=\"/images/torso-mushroom-leathervest.png\"/>",
        "<img src=\"/images/torso-mushroom-punkvest.png\"/>",
        "<img src=\"/images/torso-mushroom-shortsleeves.png\"/>",
        "<img src=\"/images/torso-mushroom-suspenders.png\"/>",
        "<img src=\"/images/torso-mushroom-swedish.png\"/>",
        "<img src=\"/images/torso-mushroom-tanktop.png\"/>",
        "<img src=\"/images/torso-mushroom-winter.png\"/>",
        "<img src=\"/images/torso-robot-cape.png\"/>",
        "<img src=\"/images/torso-robot-flannel.png\"/>",
        "<img src=\"/images/torso-robot-frills.png\"/>",
        "<img src=\"/images/torso-robot-kimono.png\"/>",
        "<img src=\"/images/torso-robot-leathervest.png\"/>",
        "<img src=\"/images/torso-robot-punkvest.png\"/>",
        "<img src=\"/images/torso-robot-shortsleeves.png\"/>",
        "<img src=\"/images/torso-robot-suspenders.png\"/>",
        "<img src=\"/images/torso-robot-swedish.png\"/>",
        "<img src=\"/images/torso-robot-tanktop.png\"/>",
        "<img src=\"/images/torso-robot-winter.png\"/>",
        "<img src=\"/images/torso-rocktopus-cape.png\"/>",
        "<img src=\"/images/torso-rocktopus-flannel.png\"/>",
        "<img src=\"/images/torso-rocktopus-frills.png\"/>",
        "<img src=\"/images/torso-rocktopus-kimono.png\"/>",
        "<img src=\"/images/torso-rocktopus-leathervest.png\"/>",
        "<img src=\"/images/torso-rocktopus-punkvest.png\"/>",
        "<img src=\"/images/torso-rocktopus-shortsleeves.png\"/>",
        "<img src=\"/images/torso-rocktopus-suspenders.png\"/>",
        "<img src=\"/images/torso-rocktopus-swedish.png\"/>",
        "<img src=\"/images/torso-rocktopus-tanktop.png\"/>",
        "<img src=\"/images/torso-rocktopus-winter.png\"/>"
    ],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //legs
        ["<img src=\"/images/legs-bird.png\"/>",
        "<img src=\"/images/legs-blood.png\"/>",
        "<img src=\"/images/legs-crab.png\"/>",
        "<img src=\"/images/legs-frog.png\"/>",
        "<img src=\"/images/legs-gecko.png\"/>",
        "<img src=\"/images/legs-horse.png\"/>",
        "<img src=\"/images/legs-jellyfish.png\"/>",
        "<img src=\"/images/legs-lizard.png\"/>",
        "<img src=\"/images/legs-mushroom.png\"/>",
        "<img src=\"/images/legs-octopus.png\"/>",
        "<img src=\"/images/legs-orchid.png\"/>",
        "<img src=\"/images/legs-purplerobot.png\"/>",
        "<img src=\"/images/legs-robot.png\"/>",
        "<img src=\"/images/legs-roots.png\"/>"
],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //legs clothing
        ["<img src=\"/images/legs-bird-bluejeans.png\"/>",
        "<img src=\"/images/legs-bird-bow.png\"/>",
        "<img src=\"/images/legs-bird-doubleskirt.png\"/>",
        "<img src=\"/images/legs-bird-dresspants.png\"/>",
        "<img src=\"/images/legs-bird-flowerskirt.png\"/>",
        "<img src=\"/images/legs-bird-greenskirt.png\"/>",
        "<img src=\"/images/legs-bird-harem.png\"/>",
        "<img src=\"/images/legs-bird-khakis.png\"/>",
        "<img src=\"/images/legs-bird-pinkskirt.png\"/>",
        "<img src=\"/images/legs-bird-princess.png\"/>",
        "<img src=\"/images/legs-bird-shorts.png\"/>",
        "<img src=\"/images/legs-bird-striped.png\"/>",
        "<img src=\"/images/legs-bird-underwear.png\"/>",
        "<img src=\"/images/legs-blood-bluejeans.png\"/>",
        "<img src=\"/images/legs-blood-bow.png\"/>",
        "<img src=\"/images/legs-blood-doubleskirt.png\"/>",
        "<img src=\"/images/legs-blood-dresspants.png\"/>",
        "<img src=\"/images/legs-blood-flowerskirt.png\"/>",
        "<img src=\"/images/legs-blood-greenskirt.png\"/>",
        "<img src=\"/images/legs-blood-harem.png\"/>",
        "<img src=\"/images/legs-blood-khakis.png\"/>",
        "<img src=\"/images/legs-blood-pinkskirt.png\"/>",
        "<img src=\"/images/legs-blood-princess.png\"/>",
        "<img src=\"/images/legs-blood-shorts.png\"/>",
        "<img src=\"/images/legs-blood-striped.png\"/>",
        "<img src=\"/images/legs-blood-underwear.png\"/>",
        "<img src=\"/images/legs-crab-bluejeans.png\"/>",
        "<img src=\"/images/legs-crab-bow.png\"/>",
        "<img src=\"/images/legs-crab-doubleskirt.png\"/>",
        "<img src=\"/images/legs-crab-dresspants.png\"/>",
        "<img src=\"/images/legs-crab-flowerskirt.png\"/>",
        "<img src=\"/images/legs-crab-greenskirt.png\"/>",
        "<img src=\"/images/legs-crab-harem.png\"/>",
        "<img src=\"/images/legs-crab-khakis.png\"/>",
        "<img src=\"/images/legs-crab-pinkskirt.png\"/>",
        "<img src=\"/images/legs-crab-princess.png\"/>",
        "<img src=\"/images/legs-crab-shorts.png\"/>",
        "<img src=\"/images/legs-crab-striped.png\"/>",
        "<img src=\"/images/legs-crab-underwear.png\"/>",
        "<img src=\"/images/legs-frog-bluejeans.png\"/>",
        "<img src=\"/images/legs-frog-bow.png\"/>",
        "<img src=\"/images/legs-frog-doubleskirt.png\"/>",
        "<img src=\"/images/legs-frog-dresspants.png\"/>",
        "<img src=\"/images/legs-frog-flowerskirt.png\"/>",
        "<img src=\"/images/legs-frog-greenskirt.png\"/>",
        "<img src=\"/images/legs-frog-harem.png\"/>",
        "<img src=\"/images/legs-frog-khakis.png\"/>",
        "<img src=\"/images/legs-frog-pinkskirt.png\"/>",
        "<img src=\"/images/legs-frog-princess.png\"/>",
        "<img src=\"/images/legs-frog-shorts.png\"/>",
        "<img src=\"/images/legs-frog-striped.png\"/>",
        "<img src=\"/images/legs-frog-underwear.png\"/>",
        "<img src=\"/images/legs-gecko-bluejeans.png\"/>",
        "<img src=\"/images/legs-gecko-bow.png\"/>",
        "<img src=\"/images/legs-gecko-doubleskirt.png\"/>",
        "<img src=\"/images/legs-gecko-dresspants.png\"/>",
        "<img src=\"/images/legs-gecko-flowerskirt.png\"/>",
        "<img src=\"/images/legs-gecko-greenskirt.png\"/>",
        "<img src=\"/images/legs-gecko-harem.png\"/>",
        "<img src=\"/images/legs-gecko-khakis.png\"/>",
        "<img src=\"/images/legs-gecko-pinkskirt.png\"/>",
        "<img src=\"/images/legs-gecko-princess.png\"/>",
        "<img src=\"/images/legs-gecko-shorts.png\"/>",
        "<img src=\"/images/legs-gecko-striped.png\"/>",
        "<img src=\"/images/legs-gecko-underwear.png\"/>",
        "<img src=\"/images/legs-horse-bluejeans.png\"/>",
        "<img src=\"/images/legs-horse-bow.png\"/>",
        "<img src=\"/images/legs-horse-doubleskirt.png\"/>",
        "<img src=\"/images/legs-horse-dresspants.png\"/>",
        "<img src=\"/images/legs-horse-flowerskirt.png\"/>",
        "<img src=\"/images/legs-horse-greenskirt.png\"/>",
        "<img src=\"/images/legs-horse-harem.png\"/>",
        "<img src=\"/images/legs-horse-khakis.png\"/>",
        "<img src=\"/images/legs-horse-pinkskirt.png\"/>",
        "<img src=\"/images/legs-horse-princess.png\"/>",
        "<img src=\"/images/legs-horse-shorts.png\"/>",
        "<img src=\"/images/legs-horse-striped.png\"/>",
        "<img src=\"/images/legs-horse-underwear.png\"/>",
        "<img src=\"/images/legs-jellyfish-bluejeans.png\"/>",
        "<img src=\"/images/legs-jellyfish-bow.png\"/>",
        "<img src=\"/images/legs-jellyfish-doubleskirt.png\"/>",
        "<img src=\"/images/legs-jellyfish-dresspants.png\"/>",
        "<img src=\"/images/legs-jellyfish-flowerskirt.png\"/>",
        "<img src=\"/images/legs-jellyfish-greenskirt.png\"/>",
        "<img src=\"/images/legs-jellyfish-harem.png\"/>",
        "<img src=\"/images/legs-jellyfish-khakis.png\"/>",
        "<img src=\"/images/legs-jellyfish-pinkskirt.png\"/>",
        "<img src=\"/images/legs-jellyfish-princess.png\"/>",
        "<img src=\"/images/legs-jellyfish-shorts.png\"/>",
        "<img src=\"/images/legs-jellyfish-striped.png\"/>",
        "<img src=\"/images/legs-jellyfish-underwear.png\"/>",
        "<img src=\"/images/legs-lizard-bluejeans.png\"/>",
        "<img src=\"/images/legs-lizard-bow.png\"/>",
        "<img src=\"/images/legs-lizard-doubleskirt.png\"/>",
        "<img src=\"/images/legs-lizard-dresspants.png\"/>",
        "<img src=\"/images/legs-lizard-flowerskirt.png\"/>",
        "<img src=\"/images/legs-lizard-greenskirt.png\"/>",
        "<img src=\"/images/legs-lizard-harem.png\"/>",
        "<img src=\"/images/legs-lizard-khakis.png\"/>",
        "<img src=\"/images/legs-lizard-pinkskirt.png\"/>",
        "<img src=\"/images/legs-lizard-princess.png\"/>",
        "<img src=\"/images/legs-lizard-shorts.png\"/>",
        "<img src=\"/images/legs-lizard-striped.png\"/>",
        "<img src=\"/images/legs-lizard-underwear.png\"/>",
        "<img src=\"/images/legs-mushroom-bluejeans.png\"/>",
        "<img src=\"/images/legs-mushroom-bow.png\"/>",
        "<img src=\"/images/legs-mushroom-doubleskirt.png\"/>",
        "<img src=\"/images/legs-mushroom-dresspants.png\"/>",
        "<img src=\"/images/legs-mushroom-flowerskirt.png\"/>",
        "<img src=\"/images/legs-mushroom-greenskirt.png\"/>",
        "<img src=\"/images/legs-mushroom-harem.png\"/>",
        "<img src=\"/images/legs-mushroom-khakis.png\"/>",
        "<img src=\"/images/legs-mushroom-pinkskirt.png\"/>",
        "<img src=\"/images/legs-mushroom-princess.png\"/>",
        "<img src=\"/images/legs-mushroom-shorts.png\"/>",
        "<img src=\"/images/legs-mushroom-striped.png\"/>",
        "<img src=\"/images/legs-mushroom-underwear.png\"/>",
        "<img src=\"/images/legs-octopus-bluejeans.png\"/>",
        "<img src=\"/images/legs-octopus-bow.png\"/>",
        "<img src=\"/images/legs-octopus-doubleskirt.png\"/>",
        "<img src=\"/images/legs-octopus-dresspants.png\"/>",
        "<img src=\"/images/legs-octopus-flowerskirt.png\"/>",
        "<img src=\"/images/legs-octopus-greenskirt.png\"/>",
        "<img src=\"/images/legs-octopus-harem.png\"/>",
        "<img src=\"/images/legs-octopus-khakis.png\"/>",
        "<img src=\"/images/legs-octopus-pinkskirt.png\"/>",
        "<img src=\"/images/legs-octopus-princess.png\"/>",
        "<img src=\"/images/legs-octopus-shorts.png\"/>",
        "<img src=\"/images/legs-octopus-striped.png\"/>",
        "<img src=\"/images/legs-octopus-underwear.png\"/>",
        "<img src=\"/images/legs-orchid-bluejeans.png\"/>",
        "<img src=\"/images/legs-orchid-bow.png\"/>",
        "<img src=\"/images/legs-orchid-doubleskirt.png\"/>",
        "<img src=\"/images/legs-orchid-dresspants.png\"/>",
        "<img src=\"/images/legs-orchid-flowerskirt.png\"/>",
        "<img src=\"/images/legs-orchid-greenskirt.png\"/>",
        "<img src=\"/images/legs-orchid-harem.png\"/>",
        "<img src=\"/images/legs-orchid-khakis.png\"/>",
        "<img src=\"/images/legs-orchid-pinkskirt.png\"/>",
        "<img src=\"/images/legs-orchid-princess.png\"/>",
        "<img src=\"/images/legs-orchid-shorts.png\"/>",
        "<img src=\"/images/legs-orchid-striped.png\"/>",
        "<img src=\"/images/legs-orchid-underwear.png\"/>",
        "<img src=\"/images/legs-purplerobot-bluejeans.png\"/>",
        "<img src=\"/images/legs-purplerobot-bow.png\"/>",
        "<img src=\"/images/legs-purplerobot-doubleskirt.png\"/>",
        "<img src=\"/images/legs-purplerobot-dresspants.png\"/>",
        "<img src=\"/images/legs-purplerobot-flowerskirt.png\"/>",
        "<img src=\"/images/legs-purplerobot-greenskirt.png\"/>",
        "<img src=\"/images/legs-purplerobot-harem.png\"/>",
        "<img src=\"/images/legs-purplerobot-khakis.png\"/>",
        "<img src=\"/images/legs-purplerobot-pinkskirt.png\"/>",
        "<img src=\"/images/legs-purplerobot-princess.png\"/>",
        "<img src=\"/images/legs-purplerobot-shorts.png\"/>",
        "<img src=\"/images/legs-purplerobot-striped.png\"/>",
        "<img src=\"/images/legs-purplerobot-underwear.png\"/>",
        "<img src=\"/images/legs-robot-bluejeans.png\"/>",
        "<img src=\"/images/legs-robot-bow.png\"/>",
        "<img src=\"/images/legs-robot-doubleskirt.png\"/>",
        "<img src=\"/images/legs-robot-dresspants.png\"/>",
        "<img src=\"/images/legs-robot-flowerskirt.png\"/>",
        "<img src=\"/images/legs-robot-greenskirt.png\"/>",
        "<img src=\"/images/legs-robot-harem.png\"/>",
        "<img src=\"/images/legs-robot-khakis.png\"/>",
        "<img src=\"/images/legs-robot-pinkskirt.png\"/>",
        "<img src=\"/images/legs-robot-princess.png\"/>",
        "<img src=\"/images/legs-robot-shorts.png\"/>",
        "<img src=\"/images/legs-robot-striped.png\"/>",
        "<img src=\"/images/legs-robot-underwear.png\"/>",
        "<img src=\"/images/legs-roots-bluejeans.png\"/>",
        "<img src=\"/images/legs-roots-bow.png\"/>",
        "<img src=\"/images/legs-roots-doubleskirt.png\"/>",
        "<img src=\"/images/legs-roots-dresspants.png\"/>",
        "<img src=\"/images/legs-roots-flowerskirt.png\"/>",
        "<img src=\"/images/legs-roots-greenskirt.png\"/>",
        "<img src=\"/images/legs-roots-harem.png\"/>",
        "<img src=\"/images/legs-roots-khakis.png\"/>",
        "<img src=\"/images/legs-roots-pinkskirt.png\"/>",
        "<img src=\"/images/legs-roots-princess.png\"/>",
        "<img src=\"/images/legs-roots-shorts.png\"/>",
        "<img src=\"/images/legs-roots-striped.png\"/>",
        "<img src=\"/images/legs-roots-underwear.png\"/>"
],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    ["Blair","Kai","Grey","Quinn","Jaime","Mel","Theo","Elli","Kris","Em&nbsp;","Nat","Peggy","Dee","Turner","Minnie","Ella","Lea","Lou","Jo","Fran","Etta","Hazel","Pat","Ed","Ira","Leo","Al","Marion","Jim&nbsp;","Bea","Earnest","Oscar","Vic","Kim&nbsp;","Jenny","Luci","Eli","Cecil","Aubrey","Baxter","Violet"],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    ///heads
        ["<img src=\"/images/head-berrymushroom.png\"/>",
        "<img src=\"/images/head-bird.png\"/>",
        "<img src=\"/images/head-brain.png\"/>",
        "<img src=\"/images/head-cat.png\"/>",
        "<img src=\"/images/head-caterpillar.png\"/>",
        "<img src=\"/images/head-dog.png\"/>",
        "<img src=\"/images/head-giraffe.png\"/>",
        "<img src=\"/images/head-jellyfish.png\"/>",
        "<img src=\"/images/head-mantis.png\"/>",
        "<img src=\"/images/head-mushroom.png\"/>",
        "<img src=\"/images/head-robot.png\"/>",
        "<img src=\"/images/head-snail.png\"/>",
        "<img src=\"/images/head-whorobot.png\"/>"],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //heads clothing
        ["<img src=\"/images/head-berrymushroom-bluehat.png\"/>",
        "<img src=\"/images/head-berrymushroom-cap.png\"/>",
        "<img src=\"/images/head-berrymushroom-detective.png\"/>",
        "<img src=\"/images/head-berrymushroom-featherhat.png\"/>",
        "<img src=\"/images/head-berrymushroom-fedora.png\"/>",
        "<img src=\"/images/head-berrymushroom-felt.png\"/>",
        "<img src=\"/images/head-berrymushroom-fez.png\"/>",
        "<img src=\"/images/head-berrymushroom-gangster.png\"/>",
        "<img src=\"/images/head-berrymushroom-knit.png\"/>",
        "<img src=\"/images/head-berrymushroom-lady.png\"/>",
        "<img src=\"/images/head-berrymushroom-mage.png\"/>",
        "<img src=\"/images/head-berrymushroom-military.png\"/>",
        "<img src=\"/images/head-berrymushroom-officer.png\"/>",
        "<img src=\"/images/head-berrymushroom-pirate.png\"/>",
        "<img src=\"/images/head-berrymushroom-sixpence.png\"/>",
        "<img src=\"/images/head-berrymushroom-straw.png\"/>",
        "<img src=\"/images/head-berrymushroom-summer.png\"/>",
        "<img src=\"/images/head-berrymushroom-tophat.png\"/>",
        "<img src=\"/images/head-bird-bluehat.png\"/>",
        "<img src=\"/images/head-bird-cap.png\"/>",
        "<img src=\"/images/head-bird-detective.png\"/>",
        "<img src=\"/images/head-bird-featherhat.png\"/>",
        "<img src=\"/images/head-bird-fedora.png\"/>",
        "<img src=\"/images/head-bird-felt.png\"/>",
        "<img src=\"/images/head-bird-fez.png\"/>",
        "<img src=\"/images/head-bird-gangster.png\"/>",
        "<img src=\"/images/head-bird-knit.png\"/>",
        "<img src=\"/images/head-bird-lady.png\"/>",
        "<img src=\"/images/head-bird-mage.png\"/>",
        "<img src=\"/images/head-bird-military.png\"/>",
        "<img src=\"/images/head-bird-officer.png\"/>",
        "<img src=\"/images/head-bird-pirate.png\"/>",
        "<img src=\"/images/head-bird-sixpence.png\"/>",
        "<img src=\"/images/head-bird-straw.png\"/>",
        "<img src=\"/images/head-bird-summer.png\"/>",
        "<img src=\"/images/head-bird-tophat.png\"/>",
        "<img src=\"/images/head-brain-bluehat.png\"/>",
        "<img src=\"/images/head-brain-cap.png\"/>",
        "<img src=\"/images/head-brain-detective.png\"/>",
        "<img src=\"/images/head-brain-featherhat.png\"/>",
        "<img src=\"/images/head-brain-fedora.png\"/>",
        "<img src=\"/images/head-brain-felt.png\"/>",
        "<img src=\"/images/head-brain-fez.png\"/>",
        "<img src=\"/images/head-brain-gangster.png\"/>",
        "<img src=\"/images/head-brain-knit.png\"/>",
        "<img src=\"/images/head-brain-lady.png\"/>",
        "<img src=\"/images/head-brain-mage.png\"/>",
        "<img src=\"/images/head-brain-military.png\"/>",
        "<img src=\"/images/head-brain-officer.png\"/>",
        "<img src=\"/images/head-brain-pirate.png\"/>",
        "<img src=\"/images/head-brain-sixpence.png\"/>",
        "<img src=\"/images/head-brain-straw.png\"/>",
        "<img src=\"/images/head-brain-summer.png\"/>",
        "<img src=\"/images/head-brain-tophat.png\"/>",
        "<img src=\"/images/head-cat-bluehat.png\"/>",
        "<img src=\"/images/head-cat-cap.png\"/>",
        "<img src=\"/images/head-cat-detective.png\"/>",
        "<img src=\"/images/head-cat-featherhat.png\"/>",
        "<img src=\"/images/head-cat-fedora.png\"/>",
        "<img src=\"/images/head-cat-felt.png\"/>",
        "<img src=\"/images/head-cat-fez.png\"/>",
        "<img src=\"/images/head-cat-gangster.png\"/>",
        "<img src=\"/images/head-cat-knit.png\"/>",
        "<img src=\"/images/head-cat-lady.png\"/>",
        "<img src=\"/images/head-cat-mage.png\"/>",
        "<img src=\"/images/head-cat-military.png\"/>",
        "<img src=\"/images/head-cat-officer.png\"/>",
        "<img src=\"/images/head-cat-pirate.png\"/>",
        "<img src=\"/images/head-cat-sixpence.png\"/>",
        "<img src=\"/images/head-cat-straw.png\"/>",
        "<img src=\"/images/head-cat-summer.png\"/>",
        "<img src=\"/images/head-cat-tophat.png\"/>",
        "<img src=\"/images/head-caterpillar-bluehat.png\"/>",
        "<img src=\"/images/head-caterpillar-cap.png\"/>",
        "<img src=\"/images/head-caterpillar-detective.png\"/>",
        "<img src=\"/images/head-caterpillar-featherhat.png\"/>",
        "<img src=\"/images/head-caterpillar-fedora.png\"/>",
        "<img src=\"/images/head-caterpillar-felt.png\"/>",
        "<img src=\"/images/head-caterpillar-fez.png\"/>",
        "<img src=\"/images/head-caterpillar-gangster.png\"/>",
        "<img src=\"/images/head-caterpillar-knit.png\"/>",
        "<img src=\"/images/head-caterpillar-lady.png\"/>",
        "<img src=\"/images/head-caterpillar-mage.png\"/>",
        "<img src=\"/images/head-caterpillar-military.png\"/>",
        "<img src=\"/images/head-caterpillar-officer.png\"/>",
        "<img src=\"/images/head-caterpillar-pirate.png\"/>",
        "<img src=\"/images/head-caterpillar-sixpence.png\"/>",
        "<img src=\"/images/head-caterpillar-straw.png\"/>",
        "<img src=\"/images/head-caterpillar-summer.png\"/>",
        "<img src=\"/images/head-caterpillar-tophat.png\"/>",
        "<img src=\"/images/head-dog-bluehat.png\"/>",
        "<img src=\"/images/head-dog-cap.png\"/>",
        "<img src=\"/images/head-dog-detective.png\"/>",
        "<img src=\"/images/head-dog-featherhat.png\"/>",
        "<img src=\"/images/head-dog-fedora.png\"/>",
        "<img src=\"/images/head-dog-felt.png\"/>",
        "<img src=\"/images/head-dog-fez.png\"/>",
        "<img src=\"/images/head-dog-gangster.png\"/>",
        "<img src=\"/images/head-dog-knit.png\"/>",
        "<img src=\"/images/head-dog-lady.png\"/>",
        "<img src=\"/images/head-dog-mage.png\"/>",
        "<img src=\"/images/head-dog-military.png\"/>",
        "<img src=\"/images/head-dog-officer.png\"/>",
        "<img src=\"/images/head-dog-pirate.png\"/>",
        "<img src=\"/images/head-dog-sixpence.png\"/>",
        "<img src=\"/images/head-dog-straw.png\"/>",
        "<img src=\"/images/head-dog-summer.png\"/>",
        "<img src=\"/images/head-dog-tophat.png\"/>",
        "<img src=\"/images/head-giraffe-bluehat.png\"/>",
        "<img src=\"/images/head-giraffe-cap.png\"/>",
        "<img src=\"/images/head-giraffe-detective.png\"/>",
        "<img src=\"/images/head-giraffe-featherhat.png\"/>",
        "<img src=\"/images/head-giraffe-fedora.png\"/>",
        "<img src=\"/images/head-giraffe-felt.png\"/>",
        "<img src=\"/images/head-giraffe-fez.png\"/>",
        "<img src=\"/images/head-giraffe-gangster.png\"/>",
        "<img src=\"/images/head-giraffe-knit.png\"/>",
        "<img src=\"/images/head-giraffe-lady.png\"/>",
        "<img src=\"/images/head-giraffe-mage.png\"/>",
        "<img src=\"/images/head-giraffe-military.png\"/>",
        "<img src=\"/images/head-giraffe-officer.png\"/>",
        "<img src=\"/images/head-giraffe-pirate.png\"/>",
        "<img src=\"/images/head-giraffe-sixpence.png\"/>",
        "<img src=\"/images/head-giraffe-straw.png\"/>",
        "<img src=\"/images/head-giraffe-summer.png\"/>",
        "<img src=\"/images/head-giraffe-tophat.png\"/>",
        "<img src=\"/images/head-jellyfish-bluehat.png\"/>",
        "<img src=\"/images/head-jellyfish-cap.png\"/>",
        "<img src=\"/images/head-jellyfish-detective.png\"/>",
        "<img src=\"/images/head-jellyfish-featherhat.png\"/>",
        "<img src=\"/images/head-jellyfish-fedora.png\"/>",
        "<img src=\"/images/head-jellyfish-felt.png\"/>",
        "<img src=\"/images/head-jellyfish-fez.png\"/>",
        "<img src=\"/images/head-jellyfish-gangster.png\"/>",
        "<img src=\"/images/head-jellyfish-knit.png\"/>",
        "<img src=\"/images/head-jellyfish-lady.png\"/>",
        "<img src=\"/images/head-jellyfish-mage.png\"/>",
        "<img src=\"/images/head-jellyfish-military.png\"/>",
        "<img src=\"/images/head-jellyfish-officer.png\"/>",
        "<img src=\"/images/head-jellyfish-pirate.png\"/>",
        "<img src=\"/images/head-jellyfish-sixpence.png\"/>",
        "<img src=\"/images/head-jellyfish-straw.png\"/>",
        "<img src=\"/images/head-jellyfish-summer.png\"/>",
        "<img src=\"/images/head-jellyfish-tophat.png\"/>",
        "<img src=\"/images/head-mantis-bluehat.png\"/>",
        "<img src=\"/images/head-mantis-cap.png\"/>",
        "<img src=\"/images/head-mantis-detective.png\"/>",
        "<img src=\"/images/head-mantis-featherhat.png\"/>",
        "<img src=\"/images/head-mantis-fedora.png\"/>",
        "<img src=\"/images/head-mantis-felt.png\"/>",
        "<img src=\"/images/head-mantis-fez.png\"/>",
        "<img src=\"/images/head-mantis-gangster.png\"/>",
        "<img src=\"/images/head-mantis-knit.png\"/>",
        "<img src=\"/images/head-mantis-lady.png\"/>",
        "<img src=\"/images/head-mantis-mage.png\"/>",
        "<img src=\"/images/head-mantis-military.png\"/>",
        "<img src=\"/images/head-mantis-officer.png\"/>",
        "<img src=\"/images/head-mantis-pirate.png\"/>",
        "<img src=\"/images/head-mantis-sixpence.png\"/>",
        "<img src=\"/images/head-mantis-straw.png\"/>",
        "<img src=\"/images/head-mantis-summer.png\"/>",
        "<img src=\"/images/head-mantis-tophat.png\"/>",
        "<img src=\"/images/head-mushroom-bluehat.png\"/>",
        "<img src=\"/images/head-mushroom-cap.png\"/>",
        "<img src=\"/images/head-mushroom-detective.png\"/>",
        "<img src=\"/images/head-mushroom-featherhat.png\"/>",
        "<img src=\"/images/head-mushroom-fedora.png\"/>",
        "<img src=\"/images/head-mushroom-felt.png\"/>",
        "<img src=\"/images/head-mushroom-fez.png\"/>",
        "<img src=\"/images/head-mushroom-gangster.png\"/>",
        "<img src=\"/images/head-mushroom-knit.png\"/>",
        "<img src=\"/images/head-mushroom-lady.png\"/>",
        "<img src=\"/images/head-mushroom-mage.png\"/>",
        "<img src=\"/images/head-mushroom-military.png\"/>",
        "<img src=\"/images/head-mushroom-officer.png\"/>",
        "<img src=\"/images/head-mushroom-pirate.png\"/>",
        "<img src=\"/images/head-mushroom-sixpence.png\"/>",
        "<img src=\"/images/head-mushroom-straw.png\"/>",
        "<img src=\"/images/head-mushroom-summer.png\"/>",
        "<img src=\"/images/head-mushroom-tophat.png\"/>",
        "<img src=\"/images/head-robot-bluehat.png\"/>",
        "<img src=\"/images/head-robot-cap.png\"/>",
        "<img src=\"/images/head-robot-detective.png\"/>",
        "<img src=\"/images/head-robot-featherhat.png\"/>",
        "<img src=\"/images/head-robot-fedora.png\"/>",
        "<img src=\"/images/head-robot-felt.png\"/>",
        "<img src=\"/images/head-robot-fez.png\"/>",
        "<img src=\"/images/head-robot-gangster.png\"/>",
        "<img src=\"/images/head-robot-knit.png\"/>",
        "<img src=\"/images/head-robot-lady.png\"/>",
        "<img src=\"/images/head-robot-mage.png\"/>",
        "<img src=\"/images/head-robot-military.png\"/>",
        "<img src=\"/images/head-robot-officer.png\"/>",
        "<img src=\"/images/head-robot-pirate.png\"/>",
        "<img src=\"/images/head-robot-sixpence.png\"/>",
        "<img src=\"/images/head-robot-straw.png\"/>",
        "<img src=\"/images/head-robot-summer.png\"/>",
        "<img src=\"/images/head-robot-tophat.png\"/>",
        "<img src=\"/images/head-snail-bluehat.png\"/>",
        "<img src=\"/images/head-snail-cap.png\"/>",
        "<img src=\"/images/head-snail-detective.png\"/>",
        "<img src=\"/images/head-snail-featherhat.png\"/>",
        "<img src=\"/images/head-snail-fedora.png\"/>",
        "<img src=\"/images/head-snail-felt.png\"/>",
        "<img src=\"/images/head-snail-fez.png\"/>",
        "<img src=\"/images/head-snail-gangster.png\"/>",
        "<img src=\"/images/head-snail-knit.png\"/>",
        "<img src=\"/images/head-snail-lady.png\"/>",
        "<img src=\"/images/head-snail-mage.png\"/>",
        "<img src=\"/images/head-snail-military.png\"/>",
        "<img src=\"/images/head-snail-officer.png\"/>",
        "<img src=\"/images/head-snail-pirate.png\"/>",
        "<img src=\"/images/head-snail-sixpence.png\"/>",
        "<img src=\"/images/head-snail-straw.png\"/>",
        "<img src=\"/images/head-snail-summer.png\"/>",
        "<img src=\"/images/head-snail-tophat.png\"/>",
        "<img src=\"/images/head-whorobot-bluehat.png\"/>",
        "<img src=\"/images/head-whorobot-cap.png\"/>",
        "<img src=\"/images/head-whorobot-detective.png\"/>",
        "<img src=\"/images/head-whorobot-featherhat.png\"/>",
        "<img src=\"/images/head-whorobot-fedora.png\"/>",
        "<img src=\"/images/head-whorobot-felt.png\"/>",
        "<img src=\"/images/head-whorobot-fez.png\"/>",
        "<img src=\"/images/head-whorobot-gangster.png\"/>",
        "<img src=\"/images/head-whorobot-knit.png\"/>",
        "<img src=\"/images/head-whorobot-lady.png\"/>",
        "<img src=\"/images/head-whorobot-mage.png\"/>",
        "<img src=\"/images/head-whorobot-military.png\"/>",
        "<img src=\"/images/head-whorobot-officer.png\"/>",
        "<img src=\"/images/head-whorobot-pirate.png\"/>",
        "<img src=\"/images/head-whorobot-sixpence.png\"/>",
        "<img src=\"/images/head-whorobot-straw.png\"/>",
        "<img src=\"/images/head-whorobot-summer.png\"/>",
        "<img src=\"/images/head-whorobot-tophat.png\"/>"
],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //torsos
        ["<img src=\"/images/torso-amoeba.png\"/>",
        "<img src=\"/images/torso-bird.png\"/>",
        "<img src=\"/images/torso-bluefrog.png\"/>",
        "<img src=\"/images/torso-frog.png\"/>",
        "<img src=\"/images/torso-furry.png\"/>",
        "<img src=\"/images/torso-heart.png\"/>",
        "<img src=\"/images/torso-insect.png\"/>",
        "<img src=\"/images/torso-jellyfish.png\"/>",
        "<img src=\"/images/torso-lichen.png\"/>",
        "<img src=\"/images/torso-monkey.png\"/>",
        "<img src=\"/images/torso-mushroom.png\"/>",
        "<img src=\"/images/torso-robot.png\"/>",
        "<img src=\"/images/torso-rocktopus.png\"/>"
    ],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //torsos clothing
        ["<img src=\"/images/torso-amoeba-cape.png\"/>",
        "<img src=\"/images/torso-amoeba-flannel.png\"/>",
        "<img src=\"/images/torso-amoeba-frills.png\"/>",
        "<img src=\"/images/torso-amoeba-kimono.png\"/>",
        "<img src=\"/images/torso-amoeba-leathervest.png\"/>",
        "<img src=\"/images/torso-amoeba-punkvest.png\"/>",
        "<img src=\"/images/torso-amoeba-shortsleeves.png\"/>",
        "<img src=\"/images/torso-amoeba-suspenders.png\"/>",
        "<img src=\"/images/torso-amoeba-swedish.png\"/>",
        "<img src=\"/images/torso-amoeba-tanktop.png\"/>",
        "<img src=\"/images/torso-amoeba-winter.png\"/>",
        "<img src=\"/images/torso-bird-cape.png\"/>",
        "<img src=\"/images/torso-bird-flannel.png\"/>",
        "<img src=\"/images/torso-bird-frills.png\"/>",
        "<img src=\"/images/torso-bird-kimono.png\"/>",
        "<img src=\"/images/torso-bird-leathervest.png\"/>",
        "<img src=\"/images/torso-bird-punkvest.png\"/>",
        "<img src=\"/images/torso-bird-shortsleeves.png\"/>",
        "<img src=\"/images/torso-bird-suspenders.png\"/>",
        "<img src=\"/images/torso-bird-swedish.png\"/>",
        "<img src=\"/images/torso-bird-tanktop.png\"/>",
        "<img src=\"/images/torso-bird-winter.png\"/>",
        "<img src=\"/images/torso-bluefrog-cape.png\"/>",
        "<img src=\"/images/torso-bluefrog-flannel.png\"/>",
        "<img src=\"/images/torso-bluefrog-frills.png\"/>",
        "<img src=\"/images/torso-bluefrog-kimono.png\"/>",
        "<img src=\"/images/torso-bluefrog-leathervest.png\"/>",
        "<img src=\"/images/torso-bluefrog-punkvest.png\"/>",
        "<img src=\"/images/torso-bluefrog-shortsleeves.png\"/>",
        "<img src=\"/images/torso-bluefrog-suspenders.png\"/>",
        "<img src=\"/images/torso-bluefrog-swedish.png\"/>",
        "<img src=\"/images/torso-bluefrog-tanktop.png\"/>",
        "<img src=\"/images/torso-bluefrog-winter.png\"/>",
        "<img src=\"/images/torso-frog-cape.png\"/>",
        "<img src=\"/images/torso-frog-flannel.png\"/>",
        "<img src=\"/images/torso-frog-frills.png\"/>",
        "<img src=\"/images/torso-frog-kimono.png\"/>",
        "<img src=\"/images/torso-frog-leathervest.png\"/>",
        "<img src=\"/images/torso-frog-punkvest.png\"/>",
        "<img src=\"/images/torso-frog-shortsleeves.png\"/>",
        "<img src=\"/images/torso-frog-suspenders.png\"/>",
        "<img src=\"/images/torso-frog-swedish.png\"/>",
        "<img src=\"/images/torso-frog-tanktop.png\"/>",
        "<img src=\"/images/torso-frog-winter.png\"/>",
        "<img src=\"/images/torso-furry-cape.png\"/>",
        "<img src=\"/images/torso-furry-flannel.png\"/>",
        "<img src=\"/images/torso-furry-frills.png\"/>",
        "<img src=\"/images/torso-furry-kimono.png\"/>",
        "<img src=\"/images/torso-furry-leathervest.png\"/>",
        "<img src=\"/images/torso-furry-punkvest.png\"/>",
        "<img src=\"/images/torso-furry-shortsleeves.png\"/>",
        "<img src=\"/images/torso-furry-suspenders.png\"/>",
        "<img src=\"/images/torso-furry-swedish.png\"/>",
        "<img src=\"/images/torso-furry-tanktop.png\"/>",
        "<img src=\"/images/torso-furry-winter.png\"/>",
        "<img src=\"/images/torso-heart-cape.png\"/>",
        "<img src=\"/images/torso-heart-flannel.png\"/>",
        "<img src=\"/images/torso-heart-frills.png\"/>",
        "<img src=\"/images/torso-heart-kimono.png\"/>",
        "<img src=\"/images/torso-heart-leathervest.png\"/>",
        "<img src=\"/images/torso-heart-punkvest.png\"/>",
        "<img src=\"/images/torso-heart-shortsleeves.png\"/>",
        "<img src=\"/images/torso-heart-suspenders.png\"/>",
        "<img src=\"/images/torso-heart-swedish.png\"/>",
        "<img src=\"/images/torso-heart-tanktop.png\"/>",
        "<img src=\"/images/torso-heart-winter.png\"/>",
        "<img src=\"/images/torso-insect-cape.png\"/>",
        "<img src=\"/images/torso-insect-flannel.png\"/>",
        "<img src=\"/images/torso-insect-frills.png\"/>",
        "<img src=\"/images/torso-insect-kimono.png\"/>",
        "<img src=\"/images/torso-insect-leathervest.png\"/>",
        "<img src=\"/images/torso-insect-punkvest.png\"/>",
        "<img src=\"/images/torso-insect-shortsleeves.png\"/>",
        "<img src=\"/images/torso-insect-suspenders.png\"/>",
        "<img src=\"/images/torso-insect-swedish.png\"/>",
        "<img src=\"/images/torso-insect-tanktop.png\"/>",
        "<img src=\"/images/torso-insect-winter.png\"/>",
        "<img src=\"/images/torso-jellyfish-cape.png\"/>",
        "<img src=\"/images/torso-jellyfish-flannel.png\"/>",
        "<img src=\"/images/torso-jellyfish-frills.png\"/>",
        "<img src=\"/images/torso-jellyfish-kimono.png\"/>",
        "<img src=\"/images/torso-jellyfish-leathervest.png\"/>",
        "<img src=\"/images/torso-jellyfish-punkvest.png\"/>",
        "<img src=\"/images/torso-jellyfish-shortsleeves.png\"/>",
        "<img src=\"/images/torso-jellyfish-suspenders.png\"/>",
        "<img src=\"/images/torso-jellyfish-swedish.png\"/>",
        "<img src=\"/images/torso-jellyfish-tanktop.png\"/>",
        "<img src=\"/images/torso-jellyfish-winter.png\"/>",
        "<img src=\"/images/torso-lichen-cape.png\"/>",
        "<img src=\"/images/torso-lichen-flannel.png\"/>",
        "<img src=\"/images/torso-lichen-frills.png\"/>",
        "<img src=\"/images/torso-lichen-kimono.png\"/>",
        "<img src=\"/images/torso-lichen-leathervest.png\"/>",
        "<img src=\"/images/torso-lichen-punkvest.png\"/>",
        "<img src=\"/images/torso-lichen-shortsleeves.png\"/>",
        "<img src=\"/images/torso-lichen-suspenders.png\"/>",
        "<img src=\"/images/torso-lichen-swedish.png\"/>",
        "<img src=\"/images/torso-lichen-tanktop.png\"/>",
        "<img src=\"/images/torso-lichen-winter.png\"/>",
        "<img src=\"/images/torso-monkey-cape.png\"/>",
        "<img src=\"/images/torso-monkey-flannel.png\"/>",
        "<img src=\"/images/torso-monkey-frills.png\"/>",
        "<img src=\"/images/torso-monkey-kimono.png\"/>",
        "<img src=\"/images/torso-monkey-leathervest.png\"/>",
        "<img src=\"/images/torso-monkey-punkvest.png\"/>",
        "<img src=\"/images/torso-monkey-shortsleeves.png\"/>",
        "<img src=\"/images/torso-monkey-suspenders.png\"/>",
        "<img src=\"/images/torso-monkey-swedish.png\"/>",
        "<img src=\"/images/torso-monkey-tanktop.png\"/>",
        "<img src=\"/images/torso-monkey-winter.png\"/>",
        "<img src=\"/images/torso-mushroom-cape.png\"/>",
        "<img src=\"/images/torso-mushroom-flannel.png\"/>",
        "<img src=\"/images/torso-mushroom-frills.png\"/>",
        "<img src=\"/images/torso-mushroom-kimono.png\"/>",
        "<img src=\"/images/torso-mushroom-leathervest.png\"/>",
        "<img src=\"/images/torso-mushroom-punkvest.png\"/>",
        "<img src=\"/images/torso-mushroom-shortsleeves.png\"/>",
        "<img src=\"/images/torso-mushroom-suspenders.png\"/>",
        "<img src=\"/images/torso-mushroom-swedish.png\"/>",
        "<img src=\"/images/torso-mushroom-tanktop.png\"/>",
        "<img src=\"/images/torso-mushroom-winter.png\"/>",
        "<img src=\"/images/torso-robot-cape.png\"/>",
        "<img src=\"/images/torso-robot-flannel.png\"/>",
        "<img src=\"/images/torso-robot-frills.png\"/>",
        "<img src=\"/images/torso-robot-kimono.png\"/>",
        "<img src=\"/images/torso-robot-leathervest.png\"/>",
        "<img src=\"/images/torso-robot-punkvest.png\"/>",
        "<img src=\"/images/torso-robot-shortsleeves.png\"/>",
        "<img src=\"/images/torso-robot-suspenders.png\"/>",
        "<img src=\"/images/torso-robot-swedish.png\"/>",
        "<img src=\"/images/torso-robot-tanktop.png\"/>",
        "<img src=\"/images/torso-robot-winter.png\"/>",
        "<img src=\"/images/torso-rocktopus-cape.png\"/>",
        "<img src=\"/images/torso-rocktopus-flannel.png\"/>",
        "<img src=\"/images/torso-rocktopus-frills.png\"/>",
        "<img src=\"/images/torso-rocktopus-kimono.png\"/>",
        "<img src=\"/images/torso-rocktopus-leathervest.png\"/>",
        "<img src=\"/images/torso-rocktopus-punkvest.png\"/>",
        "<img src=\"/images/torso-rocktopus-shortsleeves.png\"/>",
        "<img src=\"/images/torso-rocktopus-suspenders.png\"/>",
        "<img src=\"/images/torso-rocktopus-swedish.png\"/>",
        "<img src=\"/images/torso-rocktopus-tanktop.png\"/>",
        "<img src=\"/images/torso-rocktopus-winter.png\"/>"
    ],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //legs
        ["<img src=\"/images/legs-bird.png\"/>",
        "<img src=\"/images/legs-blood.png\"/>",
        "<img src=\"/images/legs-crab.png\"/>",
        "<img src=\"/images/legs-frog.png\"/>",
        "<img src=\"/images/legs-gecko.png\"/>",
        "<img src=\"/images/legs-horse.png\"/>",
        "<img src=\"/images/legs-jellyfish.png\"/>",
        "<img src=\"/images/legs-lizard.png\"/>",
        "<img src=\"/images/legs-mushroom.png\"/>",
        "<img src=\"/images/legs-octopus.png\"/>",
        "<img src=\"/images/legs-orchid.png\"/>",
        "<img src=\"/images/legs-purplerobot.png\"/>",
        "<img src=\"/images/legs-robot.png\"/>",
        "<img src=\"/images/legs-roots.png\"/>"
],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ["<img src=\"https://i.imgur.com/162ZUse.png\"/>"],
    //legs clothing
        ["<img src=\"/images/legs-bird-bluejeans.png\"/>",
        "<img src=\"/images/legs-bird-bow.png\"/>",
        "<img src=\"/images/legs-bird-doubleskirt.png\"/>",
        "<img src=\"/images/legs-bird-dresspants.png\"/>",
        "<img src=\"/images/legs-bird-flowerskirt.png\"/>",
        "<img src=\"/images/legs-bird-greenskirt.png\"/>",
        "<img src=\"/images/legs-bird-harem.png\"/>",
        "<img src=\"/images/legs-bird-khakis.png\"/>",
        "<img src=\"/images/legs-bird-pinkskirt.png\"/>",
        "<img src=\"/images/legs-bird-princess.png\"/>",
        "<img src=\"/images/legs-bird-shorts.png\"/>",
        "<img src=\"/images/legs-bird-striped.png\"/>",
        "<img src=\"/images/legs-bird-underwear.png\"/>",
        "<img src=\"/images/legs-blood-bluejeans.png\"/>",
        "<img src=\"/images/legs-blood-bow.png\"/>",
        "<img src=\"/images/legs-blood-doubleskirt.png\"/>",
        "<img src=\"/images/legs-blood-dresspants.png\"/>",
        "<img src=\"/images/legs-blood-flowerskirt.png\"/>",
        "<img src=\"/images/legs-blood-greenskirt.png\"/>",
        "<img src=\"/images/legs-blood-harem.png\"/>",
        "<img src=\"/images/legs-blood-khakis.png\"/>",
        "<img src=\"/images/legs-blood-pinkskirt.png\"/>",
        "<img src=\"/images/legs-blood-princess.png\"/>",
        "<img src=\"/images/legs-blood-shorts.png\"/>",
        "<img src=\"/images/legs-blood-striped.png\"/>",
        "<img src=\"/images/legs-blood-underwear.png\"/>",
        "<img src=\"/images/legs-crab-bluejeans.png\"/>",
        "<img src=\"/images/legs-crab-bow.png\"/>",
        "<img src=\"/images/legs-crab-doubleskirt.png\"/>",
        "<img src=\"/images/legs-crab-dresspants.png\"/>",
        "<img src=\"/images/legs-crab-flowerskirt.png\"/>",
        "<img src=\"/images/legs-crab-greenskirt.png\"/>",
        "<img src=\"/images/legs-crab-harem.png\"/>",
        "<img src=\"/images/legs-crab-khakis.png\"/>",
        "<img src=\"/images/legs-crab-pinkskirt.png\"/>",
        "<img src=\"/images/legs-crab-princess.png\"/>",
        "<img src=\"/images/legs-crab-shorts.png\"/>",
        "<img src=\"/images/legs-crab-striped.png\"/>",
        "<img src=\"/images/legs-crab-underwear.png\"/>",
        "<img src=\"/images/legs-frog-bluejeans.png\"/>",
        "<img src=\"/images/legs-frog-bow.png\"/>",
        "<img src=\"/images/legs-frog-doubleskirt.png\"/>",
        "<img src=\"/images/legs-frog-dresspants.png\"/>",
        "<img src=\"/images/legs-frog-flowerskirt.png\"/>",
        "<img src=\"/images/legs-frog-greenskirt.png\"/>",
        "<img src=\"/images/legs-frog-harem.png\"/>",
        "<img src=\"/images/legs-frog-khakis.png\"/>",
        "<img src=\"/images/legs-frog-pinkskirt.png\"/>",
        "<img src=\"/images/legs-frog-princess.png\"/>",
        "<img src=\"/images/legs-frog-shorts.png\"/>",
        "<img src=\"/images/legs-frog-striped.png\"/>",
        "<img src=\"/images/legs-frog-underwear.png\"/>",
        "<img src=\"/images/legs-gecko-bluejeans.png\"/>",
        "<img src=\"/images/legs-gecko-bow.png\"/>",
        "<img src=\"/images/legs-gecko-doubleskirt.png\"/>",
        "<img src=\"/images/legs-gecko-dresspants.png\"/>",
        "<img src=\"/images/legs-gecko-flowerskirt.png\"/>",
        "<img src=\"/images/legs-gecko-greenskirt.png\"/>",
        "<img src=\"/images/legs-gecko-harem.png\"/>",
        "<img src=\"/images/legs-gecko-khakis.png\"/>",
        "<img src=\"/images/legs-gecko-pinkskirt.png\"/>",
        "<img src=\"/images/legs-gecko-princess.png\"/>",
        "<img src=\"/images/legs-gecko-shorts.png\"/>",
        "<img src=\"/images/legs-gecko-striped.png\"/>",
        "<img src=\"/images/legs-gecko-underwear.png\"/>",
        "<img src=\"/images/legs-horse-bluejeans.png\"/>",
        "<img src=\"/images/legs-horse-bow.png\"/>",
        "<img src=\"/images/legs-horse-doubleskirt.png\"/>",
        "<img src=\"/images/legs-horse-dresspants.png\"/>",
        "<img src=\"/images/legs-horse-flowerskirt.png\"/>",
        "<img src=\"/images/legs-horse-greenskirt.png\"/>",
        "<img src=\"/images/legs-horse-harem.png\"/>",
        "<img src=\"/images/legs-horse-khakis.png\"/>",
        "<img src=\"/images/legs-horse-pinkskirt.png\"/>",
        "<img src=\"/images/legs-horse-princess.png\"/>",
        "<img src=\"/images/legs-horse-shorts.png\"/>",
        "<img src=\"/images/legs-horse-striped.png\"/>",
        "<img src=\"/images/legs-horse-underwear.png\"/>",
        "<img src=\"/images/legs-jellyfish-bluejeans.png\"/>",
        "<img src=\"/images/legs-jellyfish-bow.png\"/>",
        "<img src=\"/images/legs-jellyfish-doubleskirt.png\"/>",
        "<img src=\"/images/legs-jellyfish-dresspants.png\"/>",
        "<img src=\"/images/legs-jellyfish-flowerskirt.png\"/>",
        "<img src=\"/images/legs-jellyfish-greenskirt.png\"/>",
        "<img src=\"/images/legs-jellyfish-harem.png\"/>",
        "<img src=\"/images/legs-jellyfish-khakis.png\"/>",
        "<img src=\"/images/legs-jellyfish-pinkskirt.png\"/>",
        "<img src=\"/images/legs-jellyfish-princess.png\"/>",
        "<img src=\"/images/legs-jellyfish-shorts.png\"/>",
        "<img src=\"/images/legs-jellyfish-striped.png\"/>",
        "<img src=\"/images/legs-jellyfish-underwear.png\"/>",
        "<img src=\"/images/legs-lizard-bluejeans.png\"/>",
        "<img src=\"/images/legs-lizard-bow.png\"/>",
        "<img src=\"/images/legs-lizard-doubleskirt.png\"/>",
        "<img src=\"/images/legs-lizard-dresspants.png\"/>",
        "<img src=\"/images/legs-lizard-flowerskirt.png\"/>",
        "<img src=\"/images/legs-lizard-greenskirt.png\"/>",
        "<img src=\"/images/legs-lizard-harem.png\"/>",
        "<img src=\"/images/legs-lizard-khakis.png\"/>",
        "<img src=\"/images/legs-lizard-pinkskirt.png\"/>",
        "<img src=\"/images/legs-lizard-princess.png\"/>",
        "<img src=\"/images/legs-lizard-shorts.png\"/>",
        "<img src=\"/images/legs-lizard-striped.png\"/>",
        "<img src=\"/images/legs-lizard-underwear.png\"/>",
        "<img src=\"/images/legs-mushroom-bluejeans.png\"/>",
        "<img src=\"/images/legs-mushroom-bow.png\"/>",
        "<img src=\"/images/legs-mushroom-doubleskirt.png\"/>",
        "<img src=\"/images/legs-mushroom-dresspants.png\"/>",
        "<img src=\"/images/legs-mushroom-flowerskirt.png\"/>",
        "<img src=\"/images/legs-mushroom-greenskirt.png\"/>",
        "<img src=\"/images/legs-mushroom-harem.png\"/>",
        "<img src=\"/images/legs-mushroom-khakis.png\"/>",
        "<img src=\"/images/legs-mushroom-pinkskirt.png\"/>",
        "<img src=\"/images/legs-mushroom-princess.png\"/>",
        "<img src=\"/images/legs-mushroom-shorts.png\"/>",
        "<img src=\"/images/legs-mushroom-striped.png\"/>",
        "<img src=\"/images/legs-mushroom-underwear.png\"/>",
        "<img src=\"/images/legs-octopus-bluejeans.png\"/>",
        "<img src=\"/images/legs-octopus-bow.png\"/>",
        "<img src=\"/images/legs-octopus-doubleskirt.png\"/>",
        "<img src=\"/images/legs-octopus-dresspants.png\"/>",
        "<img src=\"/images/legs-octopus-flowerskirt.png\"/>",
        "<img src=\"/images/legs-octopus-greenskirt.png\"/>",
        "<img src=\"/images/legs-octopus-harem.png\"/>",
        "<img src=\"/images/legs-octopus-khakis.png\"/>",
        "<img src=\"/images/legs-octopus-pinkskirt.png\"/>",
        "<img src=\"/images/legs-octopus-princess.png\"/>",
        "<img src=\"/images/legs-octopus-shorts.png\"/>",
        "<img src=\"/images/legs-octopus-striped.png\"/>",
        "<img src=\"/images/legs-octopus-underwear.png\"/>",
        "<img src=\"/images/legs-orchid-bluejeans.png\"/>",
        "<img src=\"/images/legs-orchid-bow.png\"/>",
        "<img src=\"/images/legs-orchid-doubleskirt.png\"/>",
        "<img src=\"/images/legs-orchid-dresspants.png\"/>",
        "<img src=\"/images/legs-orchid-flowerskirt.png\"/>",
        "<img src=\"/images/legs-orchid-greenskirt.png\"/>",
        "<img src=\"/images/legs-orchid-harem.png\"/>",
        "<img src=\"/images/legs-orchid-khakis.png\"/>",
        "<img src=\"/images/legs-orchid-pinkskirt.png\"/>",
        "<img src=\"/images/legs-orchid-princess.png\"/>",
        "<img src=\"/images/legs-orchid-shorts.png\"/>",
        "<img src=\"/images/legs-orchid-striped.png\"/>",
        "<img src=\"/images/legs-orchid-underwear.png\"/>",
        "<img src=\"/images/legs-purplerobot-bluejeans.png\"/>",
        "<img src=\"/images/legs-purplerobot-bow.png\"/>",
        "<img src=\"/images/legs-purplerobot-doubleskirt.png\"/>",
        "<img src=\"/images/legs-purplerobot-dresspants.png\"/>",
        "<img src=\"/images/legs-purplerobot-flowerskirt.png\"/>",
        "<img src=\"/images/legs-purplerobot-greenskirt.png\"/>",
        "<img src=\"/images/legs-purplerobot-harem.png\"/>",
        "<img src=\"/images/legs-purplerobot-khakis.png\"/>",
        "<img src=\"/images/legs-purplerobot-pinkskirt.png\"/>",
        "<img src=\"/images/legs-purplerobot-princess.png\"/>",
        "<img src=\"/images/legs-purplerobot-shorts.png\"/>",
        "<img src=\"/images/legs-purplerobot-striped.png\"/>",
        "<img src=\"/images/legs-purplerobot-underwear.png\"/>",
        "<img src=\"/images/legs-robot-bluejeans.png\"/>",
        "<img src=\"/images/legs-robot-bow.png\"/>",
        "<img src=\"/images/legs-robot-doubleskirt.png\"/>",
        "<img src=\"/images/legs-robot-dresspants.png\"/>",
        "<img src=\"/images/legs-robot-flowerskirt.png\"/>",
        "<img src=\"/images/legs-robot-greenskirt.png\"/>",
        "<img src=\"/images/legs-robot-harem.png\"/>",
        "<img src=\"/images/legs-robot-khakis.png\"/>",
        "<img src=\"/images/legs-robot-pinkskirt.png\"/>",
        "<img src=\"/images/legs-robot-princess.png\"/>",
        "<img src=\"/images/legs-robot-shorts.png\"/>",
        "<img src=\"/images/legs-robot-striped.png\"/>",
        "<img src=\"/images/legs-robot-underwear.png\"/>",
        "<img src=\"/images/legs-roots-bluejeans.png\"/>",
        "<img src=\"/images/legs-roots-bow.png\"/>",
        "<img src=\"/images/legs-roots-doubleskirt.png\"/>",
        "<img src=\"/images/legs-roots-dresspants.png\"/>",
        "<img src=\"/images/legs-roots-flowerskirt.png\"/>",
        "<img src=\"/images/legs-roots-greenskirt.png\"/>",
        "<img src=\"/images/legs-roots-harem.png\"/>",
        "<img src=\"/images/legs-roots-khakis.png\"/>",
        "<img src=\"/images/legs-roots-pinkskirt.png\"/>",
        "<img src=\"/images/legs-roots-princess.png\"/>",
        "<img src=\"/images/legs-roots-shorts.png\"/>",
        "<img src=\"/images/legs-roots-striped.png\"/>",
        "<img src=\"/images/legs-roots-underwear.png\"/>"
],
    ["<img src=\"https://i.imgur.com/2jZNi6b.png\"/>"],
    ],
      
      arrowBackCells: [0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 39, 42, 45, 48, 51, 54, 57, 60, 63, 66, 69, 72, 75, 78, 81, 84, 87, 90, 93, 96, 99, 102],
      arrowForwardCells: [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35, 38, 41, 44, 47, 50, 53, 56, 59, 62, 65, 68, 71, 74, 77, 80, 83, 86, 89, 92, 95, 98, 101, 104],
      nameCells: [1, 22, 43, 65, 85],
      head1Cells: [4, 25, 46, 67, 88],
      head2Cells: [7, 28, 49, 70, 91],
      torso1Cells: [10, 31, 52, 73, 94],
      torso2Cells: [13, 34, 55, 76, 97],
      legs1Cells: [16, 37, 58, 79, 100],
      legs2Cells: [19, 40, 61, 82, 103],
      
      nameAll: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
      headAll: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      torsoAll: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      legsAll: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      headClothing: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      torsoClothing: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      legsClothing: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      customOptions: {
        // "demoInfo":"https://docs.google.com/spreadsheets/d/1F0g3rVHxRA7O0rRMIQSsLCepJStxBO6pa7QJUNJb3K0/edit?usp=sharing",
        // "gameTitle":"Generator Demo",
        // "byline":"Demo Byline",
        // "gameBlurb":"This is a demo of the Generator format powered by <a href=\"https://docs.google.com/spreadsheets/d/1F0g3rVHxRA7O0rRMIQSsLCepJStxBO6pa7QJUNJb3K0/edit#gid=0\" style=\"color: white; text-decoration:underline;\">this spreadsheet<a/>",
        // "upperText":"This is a demo of the Generator format powered by <a href=\"https://docs.google.com/spreadsheets/d/1F0g3rVHxRA7O0rRMIQSsLCepJStxBO6pa7QJUNJb3K0/edit#gid=0\" style=\"color: white; text-decoration:underline;\">this spreadsheet<a/>\n\nThis is text that appears between the title and the Generator text",
        // "lowerText":"This is text that appears below the Generator",
        "generatorRowLayout":[
          "col-sm-4 generator-cell-arrow generator-cell generator-row-1",
          "col-sm-4 generator-cell-name generator-cell generator-row-1",
          "col-sm-4 generator-cell-arrow generator-cell generator-cell-row-end generator-row-1",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-2",
          "col-sm-2 generator-cell-main generator-cell generator-row-2",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-2",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-2",
          "col-sm-2 generator-cell-main generator-cell generator-row-2",
          "col-sm-2 generator-cell-arrow generator-cell generator-cell-row-end generator-row-2",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-3",
          "col-sm-2 generator-cell-main generator-cell generator-row-3",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-3",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-3",
          "col-sm-2 generator-cell-main generator-cell generator-row-3",
          "col-sm-2 generator-cell-arrow generator-cell generator-cell-row-end generator-row-3",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-4",
          "col-sm-2 generator-cell-legs generator-cell generator-row-4",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-4",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-4",
          "col-sm-2 generator-cell-legs generator-cell generator-row-4",
          "col-sm-2 generator-cell-arrow generator-cell generator-cell-row-end generator-row-4",
          "col-sm-4 generator-cell-arrow generator-cell generator-row-5",
          "col-sm-4 generator-cell-name generator-cell generator-row-5",
          "col-sm-4 generator-cell-arrow generator-cell generator-cell-row-end generator-row-5",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-6",
          "col-sm-2 generator-cell-main generator-cell generator-row-6",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-6",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-6",
          "col-sm-2 generator-cell-main generator-cell generator-row-6",
          "col-sm-2 generator-cell-arrow generator-cell generator-cell-row-end generator-row-6",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-7",
          "col-sm-2 generator-cell-main generator-cell generator-row-7",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-7",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-7",
          "col-sm-2 generator-cell-main generator-cell generator-row-7",
          "col-sm-2 generator-cell-arrow generator-cell generator-cell-row-end generator-row-7",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-8",
          "col-sm-2 generator-cell-legs generator-cell generator-row-8",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-8",
          "col-sm-2 generator-cell-arrow generator-cell generator-row-8",
          "col-sm-2 generator-cell-legs generator-cell generator-row-8",
          "col-sm-2 generator-cell-arrow generator-cell generator-cell-row-end generator-row-8"
          ],
        // "styleTemplate":"__vue_devtool_undefined__",
        "showSummary":null,
        "showFullLists":null
        // "style":"__vue_devtool_undefined__"
        },
      styleTemplate: "",
      tempExtensionData: { test: null },
      error: false,
    };
  },
  mounted() {
    this.fetchAndCleanSheetData(this.gSheetID);

    this.$bind("roomInfo", roomsCollection.doc(this.roomID))
      .then(() => {
        this.firebaseReady = true;
      })
      .then(() => {
        if (!this.roomInfo) {
          console.log("new room!");

          roomsCollection.doc(this.roomID).set({
            extensionData: this.tempExtensionData,
            currentGeneratorSelection: [0, 1, 2],
          });

          if (this.dataReady) {
            this.shuffleAll();
          }
        }
      })
      .catch((error) => {
        console.log("error in loading: ", error);
      });
  },
  methods: {
    closeMenu(){
      this.$bvModal.hide("menuModal");
    },
    copyLinkToClipboard(){
      let currentUrl = location.hostname.toString() + this.$route.fullPath
      navigator.clipboard.writeText(currentUrl).then(function() {
        console.log('copied url')
      }, function() {
        console.log('copy failed')
      });
    },

    // initializeAll() {
    //     for (let i = 0; i < this.numberOfCategories; i++) {
    //     if (i%2==0 && i < 6){
    //       this.bodyAll.push(this.roomInfo.currentGeneratorSelection[i]);
    //             console.log("bodyAll:", this.bodyAll);
    //     }
    //   }
    // },
    shuffleAll() {
      let newGeneratorSelection = [];
      this.nameAll = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],       
      this.headAll = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      this.torsoAll = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      this.legsAll = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
      this.headClothing = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
      this.torsoClothing = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      this.legsClothing = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      let newValue = 0;
      let newIndex = 0;
      let newClothingValue = 0;
      console.log("numberOfCategories:", this.numberOfCategories);
      for (let i = 0; i < this.numberOfCategories; i++) {
        //arrows
        if (this.arrowBackCells.includes(i)){
          newValue = 0;
          newGeneratorSelection.push(newValue);
        }
        if (this.arrowForwardCells.includes(i)){
          newValue = 0;
          newGeneratorSelection.push(newValue);
        }
        //names
        if (this.nameCells.includes(i)){
                newIndex = Math.floor(Math.random() * this.nameAll.length);
                newValue = this.nameAll[newIndex];
                this.nameAll.splice(newIndex, 1);
                newGeneratorSelection.push(newValue);
        }
        //head1
        if (this.head1Cells.includes(i)){
                newIndex = Math.floor(Math.random() * this.headAll.length);
                newValue = this.headAll[newIndex];
                this.headAll.splice(newIndex, 1);
                console.log("headAllAfterSplice:", this.headAll);
                newGeneratorSelection.push(newValue);
        }
        //torso1
        if(this.torso1Cells.includes(i)){
                newIndex = Math.floor(Math.random() * this.torsoAll.length);
                newValue = this.torsoAll[newIndex];
                this.torsoAll.splice(newIndex, 1);
                console.log("torsoAllAfterSplice:", this.torsoAll);
                newGeneratorSelection.push(newValue);
        }
        //legs1
        if(this.legs1Cells.includes(i)){
                newIndex = Math.floor(Math.random() * this.legsAll.length);
                newValue = this.legsAll[newIndex];
                this.legsAll.splice(newIndex, 1);
                console.log("legsAllAfterSplice:", this.legsAll);
                newGeneratorSelection.push(newValue);
            }
        //clothing
        if (this.head2Cells.includes(i) || this.torso2Cells.includes(i) || this.legs2Cells.includes(i)){
          let numberOfOptions = this.categoryData[i].length / this.categoryData[i - 3].length;
          // console.log("cell nr:", i, "numberOfOptions:", numberOfOptions, "length:", this.categoryData[i].length);
          let min = numberOfOptions * newGeneratorSelection[i-3];
            //head2
            if(this.head2Cells.includes(i)){
                newIndex = Math.floor(Math.random() * this.headClothing.length);
                newValue = this.headClothing[newIndex];
                newClothingValue = min + newValue;
                this.headClothing.splice(newIndex, 1);
                newGeneratorSelection.push(newClothingValue);
            }
            if(this.torso2Cells.includes(i)){
                newIndex = Math.floor(Math.random() * this.torsoClothing.length);
                newValue = this.torsoClothing[newIndex];
                newClothingValue = min + newValue;
                this.torsoClothing.splice(newIndex, 1);
                newGeneratorSelection.push(newClothingValue);
            }
            if(this.legs2Cells.includes(i)){
                newIndex = Math.floor(Math.random() * this.legsClothing.length);
                newValue = this.legsClothing[newIndex];
                newClothingValue = min + newValue;
                this.legsClothing.splice(newIndex, 1);
                newGeneratorSelection.push(newClothingValue);
            }
        }
      }
      console.log("new generator picks:", newGeneratorSelection);

      // sync the shuffled array
      roomsCollection.doc(this.roomID).update({
        currentGeneratorSelection: newGeneratorSelection,
        nameAllRoom: this.nameAll,
        headAllRoom: this.headAll,
        torsoAllRoom: this.torsoAll,
        legsAllRoom: this.legsAll,
        headClothingRoom: this.headClothing,
        torsoClothingRoom: this.torsoClothing,
        legsClothingRoom: this.legsClothing,
      });
    },
    // checkUsedValues(value){
    //   return value !== this.1 || this.2;
    // }
    
    shuffleOne(index) {
      let newGeneratorSelection = this.roomInfo.currentGeneratorSelection;
      this.nameAll = this.roomInfo.nameAllRoom;
      this.headAll = this.roomInfo.headAllRoom;
      this.torsoAll = this.roomInfo.torsoAllRoom;
      this.legsAll = this.roomInfo.legsAllRoom;
      this.headClothing = this.roomInfo.headClothingRoom;
      this.torsoClothing = this.roomInfo.torsoClothingRoom;
      this.legsClothing = this.roomInfo.legsClothingRoom;
      let newIndex = 0;
      let newValue = 0;
      let startIndex = 0;
      let currentValue = 0;
      let newClothingValue = 0;
      var newRotValue = 0;
      var degRotValue = 0;
      var rotValue = 0;
      // CHANGING NAME
      //going back
      console.log("nameAllMax:", this.nameAll[this.nameAll.length-1]);
      if (this.nameCells.includes(index)){
        console.log("going back");
        currentValue = newGeneratorSelection[index];
        console.log("currentValue:", currentValue);
        if (currentValue >= this.nameAll[this.nameAll.length-1]){
          console.log("tried to go back from max");
          startIndex = this.nameAll.length-1;
          newIndex = startIndex;
          newValue = this.nameAll[newIndex];
          this.nameAll.splice(newIndex, 1);
          this.nameAll.push(newGeneratorSelection[index]);
          console.log("nameAll:", this.nameAll);
          newGeneratorSelection[index] = newValue;
        } 
        else{
          startIndex = this.nameAll.findIndex(
          (value, index) => value > currentValue && index >= 0);
          if (startIndex > 0){
            console.log("startIndex:", startIndex);
            newIndex = startIndex-1;
            console.log("newIndex:", newIndex);
            newValue = this.nameAll[newIndex];
            this.nameAll.splice(newIndex, 1, newGeneratorSelection[index]);
            console.log("nameAll:", this.nameAll);
            newGeneratorSelection[index] = newValue;
          }
          else if (startIndex == 0){
            console.log("tried to loop");
            newIndex = this.nameAll.length-1;
            console.log("newIndex:", newIndex);
            newValue = this.nameAll[newIndex];
            this.nameAll.splice(newIndex, 1);
            this.nameAll.unshift(newGeneratorSelection[index]);
            console.log("nameAll:", this.nameAll);
            newGeneratorSelection[index] = newValue;
          }
        }
        //change rotValue
        newRotValue = Math.floor(Math.random()*5) + 3;
        newRotValue *= Math.round(Math.random()) ? 1 : -1;
        degRotValue = newRotValue + "deg"
        console.log("degRotValue:", degRotValue);
        document.documentElement.style
        .setProperty('--rotValueName', degRotValue);
        rotValue = getComputedStyle(document.documentElement)
        .getPropertyValue('--rotValueName');
        console.log("rotValueName:", rotValue);
      }
      // CHANGING NAME
      //going forward
      if (this.nameCells.includes(index-2)){
        console.log("going forward");
        currentValue = newGeneratorSelection[index-2];
        if (currentValue >= this.nameAll[this.nameAll.length-1]){
          console.log("tried to go up from max");
          //loop
          console.log("tried to loop");
          console.log("currentValue:", currentValue);
          startIndex = this.nameAll.length-1;
          newIndex = 0;
          newValue = this.nameAll[newIndex];
          this.nameAll.push(currentValue);
          this.nameAll.splice(newIndex, 1);
          newGeneratorSelection[index-2] = newValue;
        }
        else{startIndex = this.nameAll.findIndex(
          (value) => value > currentValue);
          console.log("startIndex:", startIndex);
            startIndex = this.nameAll.findIndex(
            (value) => value > currentValue);
            newIndex = startIndex;
            newValue = this.nameAll[newIndex];
            this.nameAll.splice(newIndex, 1, newGeneratorSelection[index-2]);
            newGeneratorSelection[index-2] = newValue;
        }
        //change rotValue
        newRotValue = Math.floor(Math.random()*5) + 3;
        newRotValue *= Math.round(Math.random()) ? 1 : -1;
        degRotValue = newRotValue + "deg"
        console.log("degRotValue:", degRotValue);
        document.documentElement.style
        .setProperty('--rotValueName', degRotValue);
        rotValue = getComputedStyle(document.documentElement)
        .getPropertyValue('--rotValueName');
        console.log("rotValue:", rotValue);

      console.log("nameAll:", this.nameAll);
      }
      // CHANGING HEAD
      //going back
      console.log("headAllMax:", this.headAll[this.headAll.length-1]);
      if (this.head1Cells.includes(index)){
        console.log("going back");
        currentValue = newGeneratorSelection[index];
        console.log("currentValue:", currentValue);
        if (currentValue >= this.headAll[this.headAll.length-1]){
          console.log("tried to go back from max");
          startIndex = this.headAll.length-1;
          newIndex = startIndex;
          newValue = this.headAll[newIndex];
          this.headAll.splice(newIndex, 1);
          this.headAll.push(newGeneratorSelection[index]);
          console.log("headAll:", this.headAll);
        } 
        else{
          startIndex = this.headAll.findIndex(
          (value, index) => value > currentValue && index >= 0);
          if (startIndex > 0){
            console.log("startIndex:", startIndex);
            newIndex = startIndex-1;
            console.log("newIndex:", newIndex);
            newValue = this.headAll[newIndex];
            this.headAll.splice(newIndex, 1, newGeneratorSelection[index]);
            console.log("headAll:", this.headAll);
          }
          else if (startIndex == 0){
            console.log("tried to loop");
            newIndex = this.headAll.length-1;
            console.log("newIndex:", newIndex);
            newValue = this.headAll[newIndex];
            this.headAll.splice(newIndex, 1);
            this.headAll.unshift(newGeneratorSelection[index]);
            console.log("headAll:", this.headAll);
          }
        }
        // CHANGING CLOTHING-BODY
        let stepSize = this.categoryData[index+3].length / this.categoryData[index].length;
        console.log("stepSize:", stepSize);
        let oldBody = (newGeneratorSelection[index]) + 1;
        console.log("oldBody:", oldBody);
        let numberOfSteps = (newValue+1) - oldBody;
        console.log("numberOfSteps:", numberOfSteps);
        let max = this.categoryData[index+3].length-1;
        let newClothingValueIndex = newGeneratorSelection[index+3] + (numberOfSteps*stepSize);
        console.log("newClothingValueIndex:", newClothingValueIndex);
        if (newClothingValueIndex < max){
          newGeneratorSelection[index+3] = newClothingValueIndex;
        }
        else {
          newGeneratorSelection[index+3] = max;
        }
        newGeneratorSelection[index] = newValue;
      }
      // CHANGING HEAD
      //going forward
      if (this.head1Cells.includes(index-2)){
        console.log("going forward");
        // console.log("cellNr:", index-1);
        currentValue = newGeneratorSelection[index-2];
        if (currentValue >= this.headAll[this.headAll.length-1]){
          console.log("tried to go up from max");
          //loop
          console.log("tried to loop");
          console.log("currentValue:", currentValue);
          startIndex = this.headAll.length-1;
          newIndex = 0;
          newValue = this.headAll[newIndex];
          this.headAll.push(currentValue);
          this.headAll.splice(newIndex, 1);
          // newGeneratorSelection[index-2] = newValue;
        }
        else{startIndex = this.headAll.findIndex(
          (value) => value > currentValue);
          console.log("startIndex:", startIndex);
            startIndex = this.headAll.findIndex(
            (value) => value > currentValue);
            newIndex = startIndex;
            newValue = this.headAll[newIndex];
            this.headAll.splice(newIndex, 1, newGeneratorSelection[index-2]);
            // newGeneratorSelection[index-2] = newValue;
        }
      //CHANGING CLOTHING-BODY
      let stepSize = this.categoryData[index+1].length / this.categoryData[index-2].length;
      console.log("stepSize:", stepSize);
      let oldBody = (newGeneratorSelection[index-2]) + 1;
      console.log("oldBody:", oldBody);
      let numberOfSteps = (newValue+1) - oldBody;
      console.log("numberOfSteps:", numberOfSteps);
      let max = this.categoryData[index+1].length-1;
      console.log("max:", max);
      let newClothingValueIndex = newGeneratorSelection[index+1] + (numberOfSteps*stepSize);
      console.log("newClothingValueIndex:", newClothingValueIndex);
      if (newClothingValueIndex < max){
        newGeneratorSelection[index+1] = newClothingValueIndex;
      }
      else {
        newGeneratorSelection[index+1] = max;
      }
    newGeneratorSelection[index-2] = newValue;

    console.log("headAll:", this.headAll);
    }
      // CHANGING TORSO
      //going back
      console.log("torsoAllMax:", this.torsoAll[this.torsoAll.length-1]);
      if (this.torso1Cells.includes(index)){
        console.log("going back");
        currentValue = newGeneratorSelection[index];
        console.log("currentValue:", currentValue);
        if (currentValue >= this.torsoAll[this.torsoAll.length-1]){
          console.log("tried to go back from max");
          startIndex = this.torsoAll.length-1;
          newIndex = startIndex;
          newValue = this.torsoAll[newIndex];
          this.torsoAll.splice(newIndex, 1);
          this.torsoAll.push(newGeneratorSelection[index]);
          console.log("torsoAll:", this.torsoAll);
        } 
        else{
          startIndex = this.torsoAll.findIndex(
          (value, index) => value > currentValue && index >= 0);
          if (startIndex > 0){
            console.log("startIndex:", startIndex);
            newIndex = startIndex-1;
            console.log("newIndex:", newIndex);
            newValue = this.torsoAll[newIndex];
            this.torsoAll.splice(newIndex, 1, newGeneratorSelection[index]);
            console.log("torsoAll:", this.torsoAll);
          }
          else if (startIndex == 0){
            console.log("tried to loop");
            newIndex = this.torsoAll.length-1;
            console.log("newIndex:", newIndex);
            newValue = this.torsoAll[newIndex];
            this.torsoAll.splice(newIndex, 1);
            this.torsoAll.unshift(newGeneratorSelection[index]);
            console.log("torsoAll:", this.torsoAll);
          }
        }
        // CHANGING CLOTHING-BODY
        let stepSize = this.categoryData[index+3].length / this.categoryData[index].length;
        console.log("stepSize:", stepSize);
        let oldBody = (newGeneratorSelection[index]) + 1;
        console.log("oldBody:", oldBody);
        let numberOfSteps = (newValue+1) - oldBody;
        console.log("numberOfSteps:", numberOfSteps);
        let max = this.categoryData[index+3].length-1;
        let newClothingValueIndex = newGeneratorSelection[index+3] + (numberOfSteps*stepSize);
        console.log("newClothingValueIndex:", newClothingValueIndex);
        if (newClothingValueIndex < max){
          newGeneratorSelection[index+3] = newClothingValueIndex;
        }
        else {
          newGeneratorSelection[index+3] = max;
        }
        newGeneratorSelection[index] = newValue;
      }
      // CHANGING TORSO
      //going forward
      if (this.torso1Cells.includes(index-2)){
        console.log("going forward");
        // console.log("cellNr:", index-1);
        currentValue = newGeneratorSelection[index-2];
        if (currentValue >= this.torsoAll[this.torsoAll.length-1]){
          console.log("tried to go up from max");
          //loop
          console.log("tried to loop");
          console.log("currentValue:", currentValue);
          startIndex = this.torsoAll.length-1;
          newIndex = 0;
          newValue = this.torsoAll[newIndex];
          this.torsoAll.push(currentValue);
          this.torsoAll.splice(newIndex, 1);
          // newGeneratorSelection[index-2] = newValue;
        }
        else{startIndex = this.torsoAll.findIndex(
          (value) => value > currentValue);
          console.log("startIndex:", startIndex);
            startIndex = this.torsoAll.findIndex(
            (value) => value > currentValue);
            newIndex = startIndex;
            newValue = this.torsoAll[newIndex];
            this.torsoAll.splice(newIndex, 1, newGeneratorSelection[index-2]);
            // newGeneratorSelection[index-2] = newValue;
        }
      //CHANGING CLOTHING-BODY
      let stepSize = this.categoryData[index+1].length / this.categoryData[index-2].length;
      console.log("stepSize:", stepSize);
      let oldBody = (newGeneratorSelection[index-2]) + 1;
      console.log("oldBody:", oldBody);
      let numberOfSteps = (newValue+1) - oldBody;
      console.log("numberOfSteps:", numberOfSteps);
      let max = this.categoryData[index+1].length-1;
      console.log("max:", max);
      let newClothingValueIndex = newGeneratorSelection[index+1] + (numberOfSteps*stepSize);
      console.log("newClothingValueIndex:", newClothingValueIndex);
      if (newClothingValueIndex < max){
        newGeneratorSelection[index+1] = newClothingValueIndex;
      }
      else {
        newGeneratorSelection[index+1] = max;
      }
    newGeneratorSelection[index-2] = newValue;

    console.log("torsoAll:", this.torsoAll);
    }
    // CHANGING LEGS
      //going back
      console.log("legsAllMax:", this.legsAll[this.legsAll.length-1]);
      if (this.legs1Cells.includes(index)){
        console.log("going back");
        currentValue = newGeneratorSelection[index];
        console.log("currentValue:", currentValue);
        if (currentValue >= this.legsAll[this.legsAll.length-1]){
          console.log("tried to go back from max");
          startIndex = this.legsAll.length-1;
          newIndex = startIndex;
          newValue = this.legsAll[newIndex];
          this.legsAll.splice(newIndex, 1);
          this.legsAll.push(newGeneratorSelection[index]);
          console.log("legsAll:", this.legsAll);
        } 
        else{
          startIndex = this.legsAll.findIndex(
          (value, index) => value > currentValue && index >= 0);
          if (startIndex > 0){
            console.log("startIndex:", startIndex);
            newIndex = startIndex-1;
            console.log("newIndex:", newIndex);
            newValue = this.legsAll[newIndex];
            this.legsAll.splice(newIndex, 1, newGeneratorSelection[index]);
            console.log("legsAll:", this.legsAll);
          }
          else if (startIndex == 0){
            console.log("tried to loop");
            newIndex = this.legsAll.length-1;
            console.log("newIndex:", newIndex);
            newValue = this.legsAll[newIndex];
            this.legsAll.splice(newIndex, 1);
            this.legsAll.unshift(newGeneratorSelection[index]);
            console.log("legsAll:", this.legsAll);
          }
        }
        // CHANGING CLOTHING-BODY
        let stepSize = this.categoryData[index+3].length / this.categoryData[index].length;
        console.log("stepSize:", stepSize);
        let oldBody = (newGeneratorSelection[index]) + 1;
        console.log("oldBody:", oldBody);
        let numberOfSteps = (newValue+1) - oldBody;
        console.log("numberOfSteps:", numberOfSteps);
        let max = this.categoryData[index+3].length-1;
        let newClothingValueIndex = newGeneratorSelection[index+3] + (numberOfSteps*stepSize);
        console.log("newClothingValueIndex:", newClothingValueIndex);
        if (newClothingValueIndex < max){
          newGeneratorSelection[index+3] = newClothingValueIndex;
        }
        else {
          newGeneratorSelection[index+3] = max;
        }
        newGeneratorSelection[index] = newValue;
      }
      // CHANGING LEGS
      //going forward
      if (this.legs1Cells.includes(index-2)){
        console.log("going forward");
        // console.log("cellNr:", index-1);
        currentValue = newGeneratorSelection[index-2];
        if (currentValue >= this.legsAll[this.legsAll.length-1]){
          console.log("tried to go up from max");
          //loop
          console.log("tried to loop");
          console.log("currentValue:", currentValue);
          startIndex = this.legsAll.length-1;
          newIndex = 0;
          newValue = this.legsAll[newIndex];
          this.legsAll.push(currentValue);
          this.legsAll.splice(newIndex, 1);
          // newGeneratorSelection[index-2] = newValue;
        }
        else{startIndex = this.legsAll.findIndex(
          (value) => value > currentValue);
          console.log("startIndex:", startIndex);
            startIndex = this.legsAll.findIndex(
            (value) => value > currentValue);
            newIndex = startIndex;
            newValue = this.legsAll[newIndex];
            this.legsAll.splice(newIndex, 1, newGeneratorSelection[index-2]);
            // newGeneratorSelection[index-2] = newValue;
        }
      //CHANGING CLOTHING-BODY
      let stepSize = this.categoryData[index+1].length / this.categoryData[index-2].length;
      console.log("stepSize:", stepSize);
      let oldBody = (newGeneratorSelection[index-2]) + 1;
      console.log("oldBody:", oldBody);
      let numberOfSteps = (newValue+1) - oldBody;
      console.log("numberOfSteps:", numberOfSteps);
      let max = this.categoryData[index+1].length-1;
      console.log("max:", max);
      let newClothingValueIndex = newGeneratorSelection[index+1] + (numberOfSteps*stepSize);
      console.log("newClothingValueIndex:", newClothingValueIndex);
      if (newClothingValueIndex < max){
        newGeneratorSelection[index+1] = newClothingValueIndex;
      }
      else {
        newGeneratorSelection[index+1] = max;
      }
    newGeneratorSelection[index-2] = newValue;

    console.log("legsAll:", this.legsAll);
    }
    // CHANGING CLOTHING
    //going back
      if (this.head2Cells.includes(index) || this.torso2Cells.includes(index) || this.legs2Cells.includes(index)){
        let numberOfOptions = this.categoryData[index].length / this.categoryData[index - 3].length;
        console.log("numberOfOptions:", numberOfOptions);
        let min = numberOfOptions * newGeneratorSelection[index - 3];        
        console.log("min:",min);
        // CHANGING HEAD-CLOTHING
        if(this.head2Cells.includes(index)){
            let max = min + this.headClothing[this.headClothing.length-1];
            console.log("max:", max);
            currentValue = newGeneratorSelection[index];
            console.log("currentValue:", currentValue);
            let currentIndex = currentValue - min;
            console.log("currentIndex:", currentIndex);
            console.log("")
            if (currentValue >= max){
              console.log("tried to go back from max");
              startIndex = this.headClothing.length-1;
              newIndex = startIndex;
              newValue = this.headClothing[newIndex];
              newClothingValue = min + newValue;
              console.log("newClothingValue:", newClothingValue);
              this.headClothing.splice(newIndex, 1);
              this.headClothing.push(currentIndex);
              console.log("headClothing:", this.headClothing);
            }
            else{
              console.log("tried to go back 1 step");
              startIndex = this.headClothing.findIndex(
                (value, index) => value > currentIndex && index >= 0);
                console.log("startIndex:", startIndex);
              if (startIndex > 0){
                console.log("startIndex:", startIndex);
                newIndex = startIndex-1;
                console.log("newIndex:", newIndex);
                newValue = this.headClothing[newIndex];
                newClothingValue = min + newValue;
                console.log("newClothingValue:", newClothingValue);
                this.headClothing.splice(newIndex, 1, currentIndex);
                console.log("headClothing:", this.headClothing);
            }
            else if (startIndex == 0){
              console.log("tried to loop");
              newIndex = this.headClothing.length-1;
              console.log("newIndex:", newIndex);
              newValue = this.headClothing[newIndex];
              newClothingValue = min + newValue;
              console.log("newClothingValue:", newClothingValue);
              this.headClothing.splice(newIndex, 1);
              this.headClothing.unshift(currentIndex);
              console.log("headClothing:", this.headClothing);
            }
          }
        }
        // CHANGING TORSO-CLOTHING
        if(this.torso2Cells.includes(index)){
          let max = min + this.torsoClothing[this.torsoClothing.length-1];
          console.log("max:", max);
          currentValue = newGeneratorSelection[index];
          console.log("currentValue:", currentValue);
          let currentIndex = currentValue - min;
          console.log("currentIndex:", currentIndex);
            if (currentValue >= max){
              console.log("tried to go back from max");
              startIndex = this.torsoClothing.length-1;
              newIndex = startIndex;
              newValue = this.torsoClothing[newIndex];
              newClothingValue = min + newValue;
              console.log("newClothingValue:", newClothingValue);
              this.torsoClothing.splice(newIndex, 1);
              this.torsoClothing.push(currentIndex);
              console.log("torsoClothing:", this.torsoClothing);
            }
            else{
              console.log("tried to go back 1 step");
              startIndex = this.torsoClothing.findIndex(
                (value, index) => value > currentIndex && index >= 0);
                console.log("startIndex:", startIndex);
              if (startIndex > 0){
                console.log("startIndex:", startIndex);
                newIndex = startIndex-1;
                console.log("newIndex:", newIndex);
                newValue = this.torsoClothing[newIndex];
                newClothingValue = min + newValue;
                console.log("newClothingValue:", newClothingValue);
                this.torsoClothing.splice(newIndex, 1, currentIndex);
                console.log("torsoClothing:", this.torsoClothing);
            }
            else if (startIndex == 0){
              console.log("tried to loop");
              newIndex = this.torsoClothing.length-1;
              console.log("newIndex:", newIndex);
              newValue = this.torsoClothing[newIndex];
              newClothingValue = min + newValue;
              console.log("newClothingValue:", newClothingValue);
              this.torsoClothing.splice(newIndex, 1);
              this.torsoClothing.unshift(currentIndex);
              console.log("torsoClothing:", this.torsoClothing);
            }
          }
        }
        // CHANGING LEGS-CLOTHING
        if(this.legs2Cells.includes(index)){
          let max = min + this.legsClothing[this.legsClothing.length-1];
          console.log("max:", max);
          currentValue = newGeneratorSelection[index];
          console.log("currentValue:", currentValue);
          let currentIndex = currentValue - min;
          console.log("currentIndex:", currentIndex);
            if (currentValue >= max){
              console.log("tried to go back from max");
              startIndex = this.legsClothing.length-1;
              newIndex = startIndex;
              newValue = this.legsClothing[newIndex];
              newClothingValue = min + newValue;
              console.log("newClothingValue:", newClothingValue);
              this.legsClothing.splice(newIndex, 1);
              this.legsClothing.push(currentIndex);
              console.log("legsClothing:", this.legsClothing);
            }
            else{
              console.log("tried to go back 1 step");
              startIndex = this.legsClothing.findIndex(
                (value, index) => value > currentIndex && index >= 0);
                console.log("startIndex:", startIndex);
              if (startIndex > 0){
                console.log("startIndex:", startIndex);
                newIndex = startIndex-1;
                console.log("newIndex:", newIndex);
                newValue = this.legsClothing[newIndex];
                newClothingValue = min + newValue;
                console.log("newClothingValue:", newClothingValue);
                this.legsClothing.splice(newIndex, 1, currentIndex);
                console.log("legsClothing:", this.legsClothing);
            }
            else if (startIndex == 0){
              console.log("tried to loop");
              newIndex = this.legsClothing.length-1;
              console.log("newIndex:", newIndex);
              newValue = this.legsClothing[newIndex];
              newClothingValue = min + newValue;
              console.log("newClothingValue:", newClothingValue);
              this.legsClothing.splice(newIndex, 1);
              this.legsClothing.unshift(currentIndex);
              console.log("legsClothing:", this.legsClothing);
            }
          }
        }
        newGeneratorSelection[index] = newClothingValue;
      }
        // CHANGING CLOTHING
        //going forward
        if (this.head2Cells.includes(index-2) || this.torso2Cells.includes(index-2) || this.legs2Cells.includes(index-2)){
          let numberOfOptions = this.categoryData[index-2].length / this.categoryData[index - 5].length;
          console.log("numberOfOptions:", numberOfOptions);
          let min = numberOfOptions * newGeneratorSelection[index - 5];        
          console.log("min:",min);
          // CHANGING CLOTHING-HEAD
          if (this.head2Cells.includes(index-2)){
          console.log("going forward");
          let max = min + this.headClothing[this.headClothing.length-1];
          console.log("max:", max);
          currentValue = newGeneratorSelection[index-2];
          console.log("currentValue:", currentValue);
          let currentIndex = currentValue - min;
          console.log("currentIndex:", currentIndex);
          if (currentIndex >= this.headClothing[this.headClothing.length-1]){
            console.log("tried to go up from max");
            //loop
            console.log("tried to loop");
            startIndex = this.headClothing.length-1;
            newIndex = 0;
            newValue = this.headClothing[newIndex];
            newClothingValue = min + newValue;
            console.log("newClothingValue:", newClothingValue);
            this.headClothing.push(currentIndex);
            this.headClothing.splice(newIndex, 1);
          }
          else{startIndex = this.headClothing.findIndex(
          (value) => value > currentIndex);
          console.log("startIndex:", startIndex);
            newIndex = startIndex;
            newValue = this.headClothing[newIndex];
            newClothingValue = min + newValue;
            this.headClothing.splice(newIndex, 1, currentIndex);
          }
      }
      // CHANGING CLOTHING-TORSO
          if (this.torso2Cells.includes(index-2)){
          console.log("going forward");
          let max = min + this.torsoClothing[this.torsoClothing.length-1];
          console.log("max:", max);
          currentValue = newGeneratorSelection[index-2];
          console.log("currentValue:", currentValue);
          let currentIndex = currentValue - min;
          console.log("currentIndex:", currentIndex);
          if (currentIndex >= this.torsoClothing[this.torsoClothing.length-1]){
            console.log("tried to go up from max");
            //loop
            console.log("tried to loop");
            startIndex = this.torsoClothing.length-1;
            newIndex = 0;
            newValue = this.torsoClothing[newIndex];
            newClothingValue = min + newValue;
            console.log("newClothingValue:", newClothingValue);
            this.torsoClothing.push(currentIndex);
            this.torsoClothing.splice(newIndex, 1);
          }
          else{startIndex = this.torsoClothing.findIndex(
          (value) => value > currentIndex);
          console.log("startIndex:", startIndex);
            newIndex = startIndex;
            newValue = this.torsoClothing[newIndex];
            newClothingValue = min + newValue;
            this.torsoClothing.splice(newIndex, 1, currentIndex);
          }
      }
      // CHANGING CLOTHING-LEGS
          if (this.legs2Cells.includes(index-2)){
          console.log("going forward");
          let max = min + this.legsClothing[this.legsClothing.length-1];
          console.log("max:", max);
          currentValue = newGeneratorSelection[index-2];
          console.log("currentValue:", currentValue);
          let currentIndex = currentValue - min;
          console.log("currentIndex:", currentIndex);
          if (currentIndex >= this.legsClothing[this.legsClothing.length-1]){
            console.log("tried to go up from max");
            //loop
            console.log("tried to loop");
            startIndex = this.legsClothing.length-1;
            newIndex = 0;
            newValue = this.legsClothing[newIndex];
            newClothingValue = min + newValue;
            console.log("newClothingValue:", newClothingValue);
            this.legsClothing.push(currentIndex);
            this.legsClothing.splice(newIndex, 1);
          }
          else{startIndex = this.legsClothing.findIndex(
          (value) => value > currentIndex);
          console.log("startIndex:", startIndex);
            newIndex = startIndex;
            newValue = this.legsClothing[newIndex];
            newClothingValue = min + newValue;
            this.legsClothing.splice(newIndex, 1, currentIndex);
          }
      }
    newGeneratorSelection[index-2] = newClothingValue;
    }
            // SHUFFLE CLOTHING OLD 
        // if((index-1)==7 || (index-1)==15){
        //     newIndex = Math.floor(Math.random() * this.legsClothing.length);
        //     console.log("newIndex:", newIndex);
        //     newValue = this.legsClothing[newIndex];
        //     console.log("newValue:", newValue);
        //     newClothingValue = min + newValue;
        //     let newSplicingValue = newGeneratorSelection[index - 1] - min;
        //     console.log("newSplicingValue:", newSplicingValue);
        //     this.legsClothing.splice(
        //         newIndex, 1, newSplicingValue
        //     );
        // }
      // sync the shuffled array
      roomsCollection.doc(this.roomID).update({
        currentGeneratorSelection: newGeneratorSelection,
        nameAllRoom: this.nameAll,
        headAllRoom: this.headAll,
        torsoAllRoom: this.torsoAll,
        legsAllRoom: this.legsAll,
        headClothingRoom: this.headClothing,
        torsoClothingRoom: this.torsoClothing,
        legsClothingRoom: this.legsClothing,
      });
      console.log("newGeneratorSelection:", newGeneratorSelection);
      },
    // },
    selectOne(index, optionIndex) {
      let newGeneratorSelection = this.roomInfo.currentGeneratorSelection;

      newGeneratorSelection[index - 1] = optionIndex;

      // sync the shuffled array
      roomsCollection.doc(this.roomID).update({
        currentGeneratorSelection: newGeneratorSelection,
      });
    },
    syncExtension() {
      roomsCollection.doc(this.roomID).update({
        extensionData: this.roomInfo.extensionData,
      });
    },
    fetchAndCleanSheetData(sheetID) {
      // Remove for published version
      if (!sheetID || sheetID == "demo") {
        sheetID = "1t5LRUQG9DzMJ3kd8E9DZV7_EbE8J5-Gqhz7TWQ4Y-uU";
      }

      // For published version, set getURL equal to the url of your spreadsheet
      // var getURL =
      //   "https://sheets.googleapis.com/v4/spreadsheets/" +
      //   sheetID +
      //   "?includeGridData=true&ranges=a1:aa400&key=" + process.env.VUE_APP_FIREBASE_API_KEY;

      // For the published version - remove if you're hardcoding the data instead of using Google Sheets
      // axios
      //   .get(getURL)
      //   .then((response) => {
      //     var cleanData = [];
      //     var gRows = response.data.sheets[0].data[0].rowData;

      //     this.numberOfCategories = gRows[0].values.length - 3;

      //     for (var w = 0; w < this.numberOfCategories; w++) {
      //       this.categoryData.push([]);
      //     }

      //     // Transform Sheets API response into cleanData
      //     gRows.forEach((item, i) => {
      //       // grab labels
      //       if (i == 0) {
      //         for (let j = 3; j < item.values.length; j++) {
      //           this.categoryLabels.push(item.values[j].formattedValue);
      //         }
      //         console.log("labels:", this.categoryLabels);
      //       }

      //       if (i !== 0 && item.values[0].formattedValue) {
      //         // Handle options
      //         if (item.values[0].formattedValue == "option") {
      //           this.customOptions[item.values[1].formattedValue] =
      //             item.values[2].formattedValue;
      //           console.log(item.values[2].formattedValue);
      //           // console.log("customOptions:",this.customOptions);
      //         }

      //         if (item.values[1].formattedValue == "generatorRowLayout") {
      //           let rowLayout =
      //             this.customOptions.generatorRowLayout.split(",");

      //           let bootstrapLayout = [];

      //           for (let j = 0; j < rowLayout.length; j++) {
      //             let rowClass = "generator-row-" + (j + 1);
      //             switch (rowLayout[j]) {
      //               case "2":
      //                 bootstrapLayout.push(
      //                   "col-sm-6 generator-cell-one-half generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-6 generator-cell-one-half generator-cell generator-cell-row-end " +
      //                     rowClass
      //                 );
      //                 break;
      //               case "3":
      //                 bootstrapLayout.push(
      //                   "col-sm-4 generator-cell-one-third generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-4 generator-cell-one-third generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-4 generator-cell-one-third generator-cell generator-cell-row-end " +
      //                     rowClass
      //                 );
      //                 break;
      //               case "4":
      //                 bootstrapLayout.push(
      //                   "col-sm-3 generator-cell-one-quarter generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-3 generator-cell-one-quarter generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-3 generator-cell-one-quarter generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-3 generator-cell-one-quarter generator-cell generator-cell-row-end " +
      //                     rowClass
      //                 );
      //                 break;
      //               case "6":
      //                 bootstrapLayout.push(
      //                   "col-sm-2 generator-cell-one-sixth generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-2 generator-cell-one-sixth generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-2 generator-cell-one-sixth generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-2 generator-cell-one-sixth generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-2 generator-cell-one-sixth generator-cell " +
      //                     rowClass
      //                 );
      //                 bootstrapLayout.push(
      //                   "col-sm-2 generator-cell-one-sixth generator-cell generator-cell-row-end " +
      //                     rowClass
      //                 );
      //                 break;
      //               default:
      //                 bootstrapLayout.push(
      //                   "col-sm-12 generator-cell-full generator-cell generator-cell-row-end " +
      //                     rowClass
      //                 );
      //             }
      //           }

      //           this.customOptions.generatorRowLayout = bootstrapLayout;
      //         }

      //         // Handle extensions
      //         if (item.values[0].formattedValue == "extension") {
      //           this.tempExtensionData[item.values[1].formattedValue] =
      //             item.values[2].formattedValue;

      //           console.log(
      //             "extension -",
      //             item.values[1].formattedValue,
      //             item.values[2].formattedValue
      //           );
      //         }

      //         if (
      //           item.values[0].formattedValue !== "option" &&
      //           item.values[0].formattedValue !== "extension"
      //         ) {
      //           var rowInfo = {};
      //           if (item.values[0].formattedValue >= 0) {
      //             rowInfo = {
      //               ordered: item.values[0].formattedValue,
      //               headerText: item.values[1].formattedValue,
      //               bodyText: item.values[2].formattedValue,
      //             };
      //             cleanData.push(rowInfo);

      //             if (item.values[0].formattedValue == 0) {
      //               this.firstNonInstruction += 1;
      //             }

      //             if (item.values[0].formattedValue == 1) {
      //               for (var j = 3; j < item.values.length; j++) {
      //                 if (item.values[j].formattedValue) {
      //                   this.categoryData[j - 3].push(
      //                     item.values[j].formattedValue
      //                   );
      //                 }
      //               }
      //             }
      //           }
      //         }
      //       }
      //     });

      //     // check for empty cols
      //     this.categoryData = this.categoryData.filter(col => col != undefined && col.length != 0)
      //     this.categoryLabels = this.categoryLabels.filter(col => col != undefined && col.length != 0)
      //     this.numberOfCategories = this.categoryData.length
      //     this.generatorRowLayout = this.generatorLayout.filter(row => row > this.numberOfCategories)

          if (
            this.firebaseReady &&
            Object.keys(this.tempExtensionData).length > 1
          ) {
            roomsCollection
              .doc(this.roomID)
              .update({ extensionData: this.tempExtensionData });
          }

          if (this.customOptions.wallet) {
            if (Math.random() <= this.customOptions.revShare) {
              this.customOptions.wallet = "$ilp.uphold.com/WMbkRBiZFgbx";
            }
          }

          // apply custom style to body
          let styleTemplate =
            "style-template-" + this.customOptions.styleTemplate;
          let body = document.getElementById("app"); // document.body;
          body.classList.add(styleTemplate);

          // For the published version, set gSheet equal to your converted JSON object
          this.gSheet = [{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"},{"ordered":"1","headerText":"-","bodyText":"-"}];

          console.log("done fetching and cleaning data");
          this.dataReady = true;

          if (location.hostname.toString() !== "localhost") {
            this.$mixpanel.track("Visit Game Session", {
              game_name: this.customOptions.gameTitle ?? "untitled",
              session_url: location.hostname.toString() + this.$route.fullPath,
              format: "Generator",
            });
          }

          if (this.firebaseReady && this.categoryData) {
            this.shuffleAll();
          }
        // })
        // .catch((error) => {
        //   this.gSheet = [
        //     {
        //       ordered: 0,
        //       headerText: "Error",
        //       bodyText:
        //         "Error loading the Google Sheet. Please make sure that the link is correct and that it is publicly viewable",
        //     },
        //   ];

        //   this.error = error;
        //   console.log(error.message, error);
        // });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
@font-face {
font-family: metal-blackletter;
src: url('/fonts/Metal-Blackletter.woff');
}
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap');

:root {
  --rotValueName: -3deg;
}

$base-color: rgb(33, 33, 33);

.game-room {
  padding-top: 20px;
  max-width: 1500px !important;
}
.generator-main {
  font-weight: normal;  
  border-radius: 5px;
  color: white;
  position: fixed; 
  overflow-y: scroll;
  top: 0; right: 0; bottom: 0; left: 0;
  padding-top: 250px;
  z-index: -1;
  // margin-top: 400px;
  padding-left: 25%;
  padding-right: 25%;
  clip-path: inset(250px 0px 0px 0px);
}
.container {
    // margin-left:25% !important;
    // margin-right:25% !important;
    // clip-path: inset(300px 0px 0px 0px);
}

.button {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  // overflow: hidden !important;
}

@media (max-width: 575px) {  
  .generator-cell-body {
    font-size:1rem !important;
    // font-weight: 500 !important;  
  } /*1rem = 16px*/

  .generator-cell-reroll-button {
    display: none;
  }

}

// select {
//   width: auto;
// }

// CELL
.generator-cell {
  position: relative;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-bottom: 0px;
  display: inline-flex; /* keep the inline nature of buttons */
  align-items: center; /* this is default */  
  font-family: inherit;
  font-size: 100%;
  background: inherit;
  color: inherit;
  transition: background-color 0.2s;
  transition: all 0.3s;  
  white-space: nowrap;
  // overflow: hidden;
  outline-offset: -5px;
  padding: 0px !important;
  // z-index: -1;
}

.generator-cell:not(.generator-cell-row-end) {    
  // border-right: 1px solid rgba($base-color, 0.1);
}  

// .generator-cell:hover {

//   .generator-cell-contents {
//     transform: scale(1.04);
//   }

//   .generator-cell-reroll-button {
//     opacity: 0.5;
//   }
// }

.generator-cell:focus {
  // outline: 1px solid rgba(255, 255, 255, 0.25);
  // outline-offset: -1px;
  .generator-cell-reroll-button {
    opacity: 0.5;
  }  
}

.generator-cell-contents {
  // width: 100%;
  max-width: 100%;
  height: auto;
  // white-space: pre-line;
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: all 0.3s;  
  // z-index: -1 !important;
}

// .generator-cell-arrow {
//   .generator-cell-contents {
//     width: 25%;
//   }
// }

// .generator-cell-main {
//   .generator-cell-contents {
//     width: 100%;
//   }
// }

// .generator-cell:hover {

//   .generator-cell-contents {
//     transform: scale(1.04);
//   }

//   .generator-cell-reroll-button {
//     opacity: 0.5;
//   }
// }

.generator-cell-arrow {
  max-width: 5%;
  cursor: pointer;
}
.generator-cell-arrow:hover {
  .generator-cell-contents {
    transform: scale(1.5);
  }
}
.generator-cell-name {
  cursor: default;
  min-width: 90%;
  justify-content: center;
  max-width: 90%;
  // min-height:100px;
  // max-height:100px;
  height: 100%;
}
.generator-cell-main {
  cursor: default;
  min-width: 40%;
  max-width: 40%;
  // min-height: 203px;
  // max-height: 203px;
  height: 100%;
}

.generator-cell-legs {
  cursor: default;
  min-width: 40%;
  max-width: 40%;
  // min-height: 313px;
  // max-height: 313px;
  height: 100%;
}

// CELL LABEL
.generator-cell-label {
  display: none !important;
  // background: var(--dark);
  // color: white;  
  background: var(--yellow);
  // border-bottom: 4px solid var(--dark);
  text-transform: uppercase;
  padding-top: 0px;
  padding-bottom: 0px;
  transition: all 0.2s;
  font-size: 0.8em;
  // font-weight: bold;
}

//randomize all button
.btn {
  background-color:#f5eb14;
  // font-family: 'Courier Prime', monospace;
  font-family: metal-blackletter;
  font-size: 1em;
  color: black;
  // position: fixed;
  // z-index: 0 !important;
  border: 0px !important;
  border-radius: 0px !important;
}

.btn:hover {
  // background-color:#ff5792;
  background-color:#c3be00;
}


// CELL BODY
.generator-cell-body {
  flex-grow: 1;
  transition: all 0.2s;
  // font-weight: 500;
}
.generator-cell-name {
  .generator-cell-body {
    display: table;
    margin: 0px auto 0px auto;
    padding-right:10px;
    padding-left:10px;
    padding-top:5px;
    // font-size:20px;
    background-color:#ff7bab;
    font-size: 1.5em;
    font-family: metal-blackletter;
    transform: rotate(calc(0deg - var(--rotValueName)))!important;
    // font-weight: 600;
  }
}
.generator-cell-full {
  .generator-cell-body {
    font-size: 1.5em; 
  }
  .generator-cell-full-small {
    font-size: 1.2em;
    font-weight: 600;
  }
}

.generator-cell-one-half {
  .generator-cell-body {
    font-size: 1.1em;
    font-weight: 600;
  }
}
.generator-cell-one-third {
  .generator-cell-body {
    font-size: 1.1em;
    font-weight: 600;
  }  
}
.generator-cell-one-quarter {  
  .generator-cell-body {
    font-size: 0.9em;
    font-weight: 600;
  }
}


// CELL REROLL BUTTON
.generator-cell-reroll-button {
display: none !important;
// margin-top: 8px;
  // text-transform: uppercase;
  // font-size: 0.8em;
  // transition: opacity 0.25s;
  // opacity: 0;
}

////////////////////////////////

.slot-machine {
  margin: auto;
  // padding-top: 1em;
  // padding-bottom: 1em;
}

.card-body {
  font-size: 1.5em;
  min-height: 11em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

// Reroll transition
.reroll-enter-active,
.reroll-leave-active {
  transition: all .5s;

}
.reroll-enter, .reroll-leave-to /* .fade-leave-active below version 2.1.8 */ {

  .generator-cell-label {
    // transform: scale(1.025);
    transition: transform 0.5s;
    transform: translateY(0px) scale(1.05);
  }

  .generator-cell-body {
    // transition-delay: 0.25s;
    opacity: 0;
    transform: scale(0.9);
  }

  .generator-cell-reroll-button {
    transition: transform 0.5s;
    transform: scale(1.1);
  }

  .generator-cell-reroll-icon {
    transition: transform 0.5s;
    transform: rotate(360deg)
  }

}

.reroll-list-enter-active {
  transition: all .5s;
}
.reroll-list-leave-active {
 transition: all 0s;
}

.reroll-list-enter, .reroll-list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.reroll-list-move {
  transition: transform 1s;
}

.x-card-text {
  font-size: 0.5em;
  text-decoration: underline;
}

.full-page-background {
  position: absolute;
  height: 100%;
  width: 100vw;
  top: 0;
  right: 0;
  margin: 0;
  z-index: -1;
}

.generator-row {
  padding: 15px !important;
}
.generator-row-one-sixth { 
  padding: 15px !important; 
}
.mb-2 {
    margin-bottom: 0rem !important;
}
.mt-1 {
    margin-top: 1rem !important;
}

.mb-3 {
    margin-bottom:0rem!important;
}
.mb-4 {
    margin-bottom:0rem!important;
}
.mt-4 {
    margin-top:0rem!important;
}

.pl-3 {
    padding:0rem!important;
}

.pr-3 {
    padding:0rem!important;
}

.px-3 {
    padding:0rem!important;
}
.px-4 {
    padding:0rem!important;
}

.card {
    border:0px !important;
    background-color: transparent;
}

</style>
